import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
  memo,
} from "react";
import AgGridTable from "../../utilities/AgGridTable";
import Cards from "./Card";
import data from "./data";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import * as XLSX from "xlsx-js-style";
import { makeStyles } from "@mui/styles";
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  OutlinedInput,
  Paper,
  Switch,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  alpha,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  CircularProgress,
  Backdrop,
  useMediaQuery,
} from "@mui/material";
import FormPageHeader from "../../utilities/FormPageHeader";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import AdvancedSearch from "./AdvancedSearch";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import jwtDecode from "jwt-decode";
import { toShowroomIdList } from "../../utilities/showroomUtils";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import moment from "moment";
import Data from "./data";
import {
  CustomTextEditor,
  ActualLoadingDate,
  PlannedLoadingDate,
  ActualLoadingWeek,
  PlannedLoadingWeek,
  SelectCarcass,
  SelectDate,
  SelectFrontColor1,
  SelectFrontColor2,
  SelectFrontColor3,
  SelectHandle,
  SelectProduct,
  SelectRange1,
  SelectRange2,
  SelectRange3,
  SelectShippingType,
  SelectStatus,
  UniqueIdEditor,
} from "./celleditor-component/EditorComponent";
import { createContext } from "react";
import { CU } from "country-flag-icons/react/3x2";
import { toast } from "react-toastify";
import DialogBox from "../../utilities/DialogBox";
import { useDispatch, useSelector } from "react-redux";
import ExcelJS from "exceljs";
import TitleIcon from "@mui/icons-material/Title";
import {
  setSavedFilter,
  setFilterRowData,
  setHasFilter,
  clearFilter,
} from "app/store/filterSlice";

export const SelectedStatus = createContext();
/*--------------------------------Accordion-------------------------------------*/

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

/*---------------------------------------------------------------------------------*/
const useStyles = makeStyles((theme) => ({
  root: {
    "& .new, & .assigned, & .placed, & .ab_received, & .invoiced, & .amendment, & .inprogress":
      {
        borderRadius: "20px",
        fontSize: "11px",
        textAlign: "center",
        height: "19px",
        lineHeight: "19px",
        padding: "0px 10px",
        marginTop: "1px",
        color: theme.palette.common.white,
      },
    "& .new": {
      backgroundColor: "#0597EA",
    },
    "& .assigned": {
      backgroundColor: "#EAAA05",
    },
    "& .placed": {
      backgroundColor: "#B8B9B9",
    },
    "& .ab_received": {
      backgroundColor: "#09D404",
    },
    "& .amendment": {
      backgroundColor: "#1812BA",
    },
    "& .invoiced": {
      backgroundColor: "#09D404",
    },
    "& .inprogress": {
      backgroundColor: "#09D404",
    },
    "& .total-list": {
      justifyContent: "space-around",

      "& li": {
        padding: "5px",
        fontSize: "12px",

        "& label": {
          fontSize: "12px",
          color: `${
            theme.palette.mode === "light"
              ? theme.palette.common.black
              : theme.palette.common.white
          } !important`,
          display: "block",
        },
      },
    },
  },
}));
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    padding: "0 10px",
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

const initialValues = {
  custNum: null,
  vendorShortKey: [],
  commissionName: "",
  abNumber: "",
  orderStatus: "",
  plannedLoadingWeek: "",
  orderType: "",
  orderNum: "",
  orderCategory: [],
  categoryGroup: null,
  territory: [],
  region: [],
  showroomNum: [],
  mainPriceGrp: [],
  mainRange: [],
  mainColour: [],
  mainCarcass: [],
  mainHandle: [],
  intlContainerNum: "",
  actualContainerNum: "",
  listPort: [],
  freightId: [],
  tourNo: "",
  pdrStatus: "",
  pdpStatus: "",
  sdrStatus: [],
  sdpStatus: [],
  psdStatus: [],
  orderStatus2: null,
  createdDtFrom: null,
  createdDtTo: null,
  plannedLoadingDateFrom: null,
  plannedLoadingDateTo: null,
  actualLoadingDateFrom: null,
  actualLoadingDateTo: null,
  orderPlacedDateFrom: null,
  orderPlacedDateTo: null,
  abReceivedDateFrom: null,
  abReceivedDateTo: null,
  orderConfirmedDateFrom: null,
  orderConfirmedDateTo: null,
  fromDate: null,
  toDate: null,
  excludeCancelled: false,
  showDeleted: null,
  // pageNo: 0,
  // pageSize: 20,
};

// currentYear
const currentYear = new Date().getFullYear();

let monthOption = [];
for (let i = 1; i <= 12; i++) {
  monthOption.push({ label: i, value: i });
}

let weekOption = [];
for (let i = 1; i <= 52; i++) {
  weekOption.push({ label: i, value: i });
}

const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orders}`;
const getMyOrdersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getMyOrders}`;
const companiesUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
const searchUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getOrdersByCriteria}`;
const searchAoUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getOrdersForAOReport}`;
const resourceUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
const orderStatusUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
const findPartnerById = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
const orderCalculationURL = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getOrderListCalculation}`;
const changeOrderStatus = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.changeOrderStatus}`;
const orderToMoveSpecialDiscount = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderToMoveSpecialDiscount}`;
const downloadAbUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.downloadOrderAbFiles}`;
const restoreOrdersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.RestoreOrder}`;
var filterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    var dateAsString = cellValue;
    //Convert function date format from "2024-02-23T17:16:43.974" to 23/02/2024
    const date = new Date(dateAsString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    if (formattedDate == null) return -1;
    var dateParts = formattedDate.split("/");
    var cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0]),
    );
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
  maxValidYear: new Date().getFullYear(),
};
const OrderList = (props) => {
  // const [tabValue, setTabValue] = useState("ViewAllFields");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = useState(null);
  const [pramotionDia, setPramotionDia] = useState(false);
  const open = Boolean(anchorEl);
  const [showSearch, setShowSearch] = useState(false);
  const [listView, setListView] = useState(true);
  const [gridView, setGridView] = useState(false);
  const classes = useStyles(props);
  const navigate = useNavigate();
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [selectedRows, setSelectedRows] = useState([]);
  const [updateRowData, setUpdateRowData] = useState([]);
  const updateRowDataRef = useRef([]);
  const originalEditDataRef = useRef({});
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [autoSizeMode, setAutoSizeMode] = useState(true);
  const [showroomOptions, setShowroomOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [custCountry, setCustCountry] = useState("");
  const [factoryVendors, setFactoryVendors] = useState([]);
  const [vendorId, setVendorId] = useState("");
  const [rangeId, setRangeId] = useState();
  const [expanded, setExpanded] = useState("");
  const [selectedStatus, setSelectedStatus] = useState();
  const [yearOptions, setYearOptions] = useState();
  const [filter, setFilter] = useState(initialValues);
  const [dateType, setDateType] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState("");
  const [week, setWeek] = useState("");
  const [companyShowroom, setCompanyShowroom] = useState("");
  const [orderCalculation, setOrderCalculation] = useState([]);
  const [showOrderCharacteristics, setShowOrderCharacteristics] =
    useState(true);
  const [showLogistics, setShowLogistics] = useState(true);
  const [showCommercialRcbl, setShowCommercialRcbl] = useState(true);
  const [showCommercialPbl, setShowCommercialPbl] = useState(true);
  const [showHistory, setShowHistory] = useState(true);
  const [showApprovals, setShowApprovals] = useState(true);
  const [hasSearch, setHasSearch] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [promotionalStatus, setPromotionalStatus] = useState(false);
  const [openType, setOpenType] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [extraActionsAnchor, setExtraActionsAnchor] = useState(null);
  const openExtraActions = Boolean(extraActionsAnchor);
  const [uniqueIdEdit, setUniqueIdEdit] = useState(false);
  const [invalidUniqueIdRows, setInvalidUniqueIdRows] = useState({});
  const [invalidColorRows, setInvalidColorRows] = useState({});
  const [invalidMaterialRows, setInvalidMaterialRows] = useState({});
  const [isExportingAo, setIsExportingAo] = useState(false);
  const [checkboxStates, setCheckboxStates] = useState({
    group1: true,
    group2: true,
    group3: true,
    group4: true,
    group5: true,
    group6: true,
    group7: true,
  });
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));
  const savedFilterData = useSelector((state) => state.filter.filter);
  const filterStatus = useSelector((state) => state.filter.hasFilter);
  const cardStatus = useSelector((state) => state.filter.cardStatus);
  const dispatch = useDispatch();

  const hasCustomerRole = [
    "ROLE_PARTNRORDPROCESS",
    "ROLE_PARTNER_ADMIN",
    "ROLE_PARTNER",
    "ROLE_PARTNRDESIGN",
    "ROLE_PARTNRSALE",
    "ROLE_SHWRMMGR",
  ].some((role) => token?.scope?.includes(role));
  const hasIAMRole =
    token?.scope?.includes("ROLE_IAM") &&
    !(
      token?.scope?.includes("ROLE_ADMIN") ||
      token?.scope?.includes("ROLE_SOPDIR")
    );
  const hasLogisticsRole = ["ROLE_LOGIMGR", "ROLE_LOGISTICS"].some((role) =>
    token.scope.includes(role),
  );
  const hasPartnerOrderProRole = ["ROLE_PARTNRORDPROCESS"].some((role) =>
    token?.scope?.includes(role),
  );

  const hasPartnerAdminRole = ["ROLE_PARTNER_ADMIN"].some((role) =>
    token?.scope?.includes(role),
  );

  const hasOrderProcesorRole = ["ROLE_ORDERPRO"].some((role) =>
    token?.scope?.includes(role),
  );
  const hasShwrmMngrRole = ["ROLE_SHWRMMGR"].some((role) =>
    token?.scope?.includes(role),
  );
  const hasPartnerRole = ["ROLE_PARTNER"].some((role) =>
    token?.scope?.includes(role),
  );
  const hasSOPRole = ["ROLE_SOPDIR"].some((role) =>
    token?.scope?.includes(role),
  );

  const hasAdminRole = [
    "ROLE_ORDERPRO",
    "ROLE_SOPDIR",
    "ROLE_MD",
    "ROLE_ADMIN",
  ].some((role) => token?.scope?.includes(role));
  const hasSopAdminRole = ["ROLE_SOPDIR", "ROLE_MD", "ROLE_ADMIN"].some(
    (role) => token?.scope?.includes(role),
  );
  const customerRole = ["ROLE_PARTNRORDPROCESS", "ROLE_PARTNER_ADMIN"].some(
    (role) => token?.scope?.includes(role),
  );

  const hasOrderEditable = useMemo(() => {
    const editableOrderStatusList = [
      "NEW",
      "ASSIGNED",
      "IN_PROGRESS",
      "HOLD",
      "ORDER_PLACED",
      "ACK_FRM_FACTORY",
      "AB_RECEIVED",
      "UNDER_CONFIRMATION",
      "CONFIRMED",
      "READY_TO_BOOK",
      "PRODUCTION_PLANNING",
      "PI_GENERATED",
      "LOADED",
    ];

    const editableCustomerOrderStatusList = ["ASSIGNED", "HOLD"];
    const roles =
      hasAdminRole || hasLogisticsRole
        ? editableOrderStatusList
        : editableCustomerOrderStatusList;

    if (!selectedRows || selectedRows.length === 0) return true;

    const hasNonEditableRow = selectedRows.some(
      (row) => !roles.includes(row?.orderStatus),
    );

    return hasNonEditableRow;
  }, [hasAdminRole, selectedRows]);
  const hasOrderAbDownloadable = useMemo(() => {
    const editableOrderStatusList = [
      "AB_RECEIVED",
      "UNDER_CONFIRMATION",
      "CONFIRMED",
      "READY_TO_BOOK",
      "PRODUCTION_PLANNING",
      "PI_GENERATED",
    ];

    return (
      selectedRows.length > 0 &&
      selectedRows.every((row) =>
        editableOrderStatusList.includes(row.orderStatus),
      )
    );
  }, [selectedRows]);

  const historyOptionOther = [
    // { label: "Order Received Date", value: "orderReceivedDate" },
    { label: "Order Created Date", value: "createdDt" },
    { label: "Order Placed Date", value: "orderPlacedDate" },
    { label: "AB Received Date", value: "abReceivedDate" },
    { label: "Order Confirmed Date", value: "orderConfirmedDate" },
    { label: "Loading Plan Date", value: "plannedLoadingDate" },
    { label: "Actual Loading Date", value: "actualLoadingDate" },
  ];

  const historyOptionCustomer = historyOptionOther.filter(
    (item) => item.value == "createdDt",
  );

  const handleChangePanel = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleDateFormat = (props) => {
    return props.value && moment(props.value).format("DD-MM-YYYY");
  };

  const totalListPrice = (props) => {
    const LPWG1 = Number(props?.data?.revisedLpWg1) || 0;
    const LPWG2 = Number(props?.data?.revisedLpWg2) || 0;

    const total = LPWG1 + LPWG2;

    if (!total) return <p style={{ textAlign: "right", margin: 0 }}></p>;

    const formattedTotal = new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(total);

    return <p style={{ textAlign: "right", margin: 0 }}>{formattedTotal}</p>;
  };

  const showDiscountPercent = (props) => {
    const value = Number(props?.value);

    if (!value || isNaN(value)) return null; // hides 0, null, undefined

    const formattedValue = `${value < 0 ? "-" : ""}${Math.abs(value).toFixed(
      3,
    )}%`;

    return <p style={{ textAlign: "right", margin: 0 }}>{formattedValue}</p>;
  };
  const showDiscountPercentMoney = (props) => {
    const formattedValue = new Intl.NumberFormat("en-GB", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(props.value || 0);

    return (
      <p style={{ textAlign: "right", margin: 0 }}>{`${formattedValue}`}</p>
    );
  };
  const showFixedValue = (props) => {
    let formattedNumbers;
    if (Number.isNaN(props?.value) || props?.value === 0 || !props?.value) {
      formattedNumbers = "";
    } else {
      if (props.colDef.field === "volume" || props.colDef.field === "weight") {
        formattedNumbers = new Intl.NumberFormat("en-US", {
          maximumFractionDigits: 3,
          minimumFractionDigits: 3,
        }).format(props?.value);
      } else {
        formattedNumbers = new Intl.NumberFormat("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }).format(props?.value);
      }
    }
    return (
      <p style={{ textAlign: "right", margin: 0 }}>{`${formattedNumbers}`}</p>
    );
  };
  const getSingleSelectValue = (options, value) =>
    options?.find((opt) => opt.value === value) || null;

  const getMultiSelectValue = (options, values) =>
    Array.isArray(values)
      ? options?.filter((opt) => values.includes(opt.value))
      : [];
  const showUpdatedAbStatus = (props) => {
    if (props.value === "AB_RECEIVED") {
      if (
        props?.data?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY" ||
        props?.data?.amendmentStatus === "AMENDMENT_REQUEST_NFZE"
      ) {
        return <p>{`${props?.data?.amendmentStatus}`}</p>;
      } else {
        let status;
        if (props?.data?.abShareDate) {
          status = "AB_RECEIVED";
        } else {
          status = "ACK_FRM_FACTORY";
        }
        return <p>{`${status}`}</p>;
      }
    } else {
      return <p>{props.value}</p>;
    }
  };
  const showUpdatedAbStatusSop = (props) => {
    if (
      (props.value === "AB_RECEIVED" &&
        (props?.data?.amendmentStatus === "AMENDMENT_REQUEST_NFZE" ||
          props?.data?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY")) ||
      (props.value === "UNDER_CONFIRMATION" &&
        (props?.data?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY" ||
          props?.data?.amendmentStatus === "AMENDMENT_REQUEST_NFZE"))
    ) {
      return <p>{`${props?.data?.amendmentStatus}`}</p>;
    } else {
      return <p>{props.value}</p>;
    }
  };

  const renderFrontColor = (props) => {
    if (props?.value) {
      if (props?.colDef?.field === "color1") {
        if (props?.data?.color1Id) {
          return <div>{`${props?.data?.color1Id} - ${props?.value}`}</div>;
        } else {
          return <div>{props?.value}</div>;
        }
      }
      if (props?.colDef?.field === "color2") {
        if (props?.data?.color2Id) {
          return <div>{`${props?.data?.color2Id} - ${props?.value}`}</div>;
        } else {
          return <div>{props?.value}</div>;
        }
      }
      if (props?.colDef?.field === "color3") {
        if (props?.data?.color3Id) {
          return <div>{`${props?.data?.color3Id} - ${props?.value}`}</div>;
        } else {
          return <div>{props?.value}</div>;
        }
      }
    }
  };

  const renderCarcass = (props) => {
    if (props?.value) {
      if (props?.colDef?.field === "carcass1") {
        if (props?.data?.carcass1Id) {
          return <div>{`${props?.data?.carcass1Id} - ${props?.value}`}</div>;
        } else {
          return <div>{props?.value}</div>;
        }
      }
      if (props?.colDef?.field === "carcass2") {
        if (props?.data?.carcass2Id) {
          return <div>{`${props?.data?.carcass2Id} - ${props?.value}`}</div>;
        } else {
          return <div>{props?.value}</div>;
        }
      }
      if (props?.colDef?.field === "carcass3") {
        if (props?.data?.carcass3Id) {
          return <div>{`${props?.data?.carcass3Id} - ${props?.value}`}</div>;
        } else {
          return <div>{props?.value}</div>;
        }
      }
    }
  };

  const renderHandle = (props) => {
    if (props?.value) {
      if (props?.colDef?.field === "handle1") {
        if (props?.data?.handle1Id) {
          return <div>{`${props?.data?.handle1Id} - ${props?.value}`}</div>;
        } else {
          return <div>{props?.value}</div>;
        }
      }
      if (props?.colDef?.field === "handle2") {
        if (props?.data?.handle2Id) {
          return <div>{`${props?.data?.handle2Id} - ${props?.value}`}</div>;
        } else {
          return <div>{props?.value}</div>;
        }
      }
      if (props?.colDef?.field === "handle3") {
        if (props?.data?.handle3Id) {
          return <div>{`${props?.data?.handle3Id} - ${props?.value}`}</div>;
        } else {
          return <div>{props?.value}</div>;
        }
      }
    }
  };

  const customListPriceWG1 = (params) => {
    if (
      params?.data?.revisedLpWg1 === 0 ||
      params?.data?.revisedLpWg1 === null
    ) {
      return params?.data?.revisedLpWg1;
    }
    return params?.data?.revisedLpWg1;
  };

  const customListPriceWG2 = (params) => {
    if (
      params?.data?.revisedLpWg2 === 0 ||
      params?.data?.revisedLpWg2 === null
    ) {
      return params?.data?.revisedLpWg2;
    }
    return params?.data?.revisedLpWg2;
  };

  const ActiveSwitch = (props) => {
    return (
      <Switch
        size="small"
        checked={props?.data?.skipPromotion}
        onChange={(e) => {
          handleSwitchClick(props.data, e.target.checked);
        }}
        color="success"
      />
    );
  };

  const handleSwitchClick = (row, newValue) => {
    setSelectedRows([row]);
    setPromotionalStatus(newValue);
    setPramotionDia(true);
  };

  const handlePramotionDiaClose = () => {
    setPramotionDia(false);
  };

  const refreshCache = useCallback(() => {
    gridRef.current.api.refreshCells();
  }, []);
  const changeActiveStatus = async (e) => {
    gridRef.current.api.showLoadingOverlay();

    try {
      const updatedRows = await Promise.all(
        selectedRows.map(async (row) => {
          try {
            const model = {
              skipPromotion: promotionalStatus,
            };
            const { data } = await OAuthService.updateData(url, row.id, model);
            return data;
          } catch (error) {
            toast.error("Promotion can't be skipped");
            return null;
          }
        }),
      );

      const validUpdatedRows = updatedRows.filter((row) => row && row.id);

      if (validUpdatedRows.length > 0) {
        const newRowData = rowData.map((oldRow) => {
          const updated = validUpdatedRows.find((r) => r.id === oldRow.id);
          return updated ? updated : oldRow;
        });

        setRowData(newRowData);
      }
    } finally {
      gridRef.current.api.hideOverlay();
      refreshCache();
      setPramotionDia(false);
      // findMaterialMasterProduct();
    }
  };

  const handleOpenType = (id) => {
    setSelectedId(id);
    setOpenType(true);
  };

  const handleCloseType = () => {
    setOpenType(false);
    setSelectedId(null);
  };

  const handleNewOrderType = () => {
    navigate("/order/new-type-order/" + selectedId);
    handleCloseType();
  };

  const handlePartOrder = () => {
    navigate("/order/new-type-part-order/" + selectedId);
    handleCloseType();
  };

  const CreateNewType = ({ data, onOpen }) => {
    const id = data?.data?.id;

    if (
      data?.data?.documentType !== "SO" ||
      data?.data?.orderCategory === "PRJ" ||
      data?.data?.orderCategory === "CPRJ"
    ) {
      return null;
    }

    return (
      <Tooltip title="Create a New Type">
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onOpen(id);
          }}
        >
          <FuseSvgIcon size={14} color="action">
            heroicons-solid:plus-circle
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
    );
  };
  const [columnDefs, setColumnDefs] = useState([]);

  useEffect(() => {
    const cyear = new Date().getFullYear();

    let years = Array.from({ length: 21 }, (_, index) => {
      const year = cyear + 1 - index;
      return { label: year, value: year };
    });

    setYearOptions(years);
  }, []);
  const searchHandler = () => {
    let updatedValues = {};
    for (const key in filter) {
      if (Object.hasOwnProperty.call(filter, key)) {
        updatedValues[key] = filter[key] === "ALL" ? "" : filter[key];
      }
    }
    updatedValues.orderStatus2 = cardStatus;
    updatedValues.territory = filter?.territory;
    dispatch(setSavedFilter(updatedValues));
    dispatch(setHasFilter(true));
    setHasSearch(true);
  };
  const handleUniqueIdLiveChange = useCallback((node, rawValue) => {
    const data = node.data;
    const value = String(rawValue || "");
    const trimmedValue = value.trim();

    setInvalidUniqueIdRows((prev) => {
      const updated = { ...prev };
      if (trimmedValue === "") {
        updated[data.id] = true;
      } else {
        delete updated[data.id];
      }
      return updated;
    });

    if (!data?.commissionName) return;

    const parts = data.commissionName.split("-");
    const isPRJ = ["PRJ", "CPRJ"].includes(data.orderCategory);
    const index = isPRJ ? parts.length - 1 : parts.length - 2;

    parts[index] = value;

    const updatedName = parts.join("-").toUpperCase();

    if (updatedName.length <= 35) {
      data.commissionName = updatedName;
      gridRef.current.api.refreshCells({
        columns: ["commissionName"],
        rowNodes: [node],
      });
    }
  }, []);
  const handleColorValidityChange = useCallback(
    (rowId, colorField, isInvalid) => {
      if (!rowId) return;
      setInvalidColorRows((prev) => {
        const updated = { ...prev };
        const rowInvalids = { ...(updated[rowId] || {}) };

        if (isInvalid) {
          rowInvalids[colorField] = true;
        } else {
          delete rowInvalids[colorField];
        }

        if (Object.keys(rowInvalids).length > 0) {
          updated[rowId] = rowInvalids;
        } else {
          delete updated[rowId];
        }
        return updated;
      });
    },
    [],
  );
  const specialDiscountIcon = (params) => {
    const data = params?.data;
    if (!data) return null;

    const { commissionName, specialDiscountRequested, sdrStatus } = data;

    return (
      <span
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {commissionName}
        {sdrStatus === "APPROVED" ? (
          <FuseSvgIcon size={18} color="Green">
            heroicons-solid:tag
          </FuseSvgIcon>
        ) : sdrStatus === "WAITING" || sdrStatus === "PENDING" ? (
          <FuseSvgIcon size={18} color="Red">
            heroicons-solid:tag
          </FuseSvgIcon>
        ) : (
          ""
        )}
      </span>
    );
  };

  const getColumns = (isMobile) => ({
    hasCustomerRoleCol: [
      {
        cellRenderer: (params) => (
          <CreateNewType data={params} onOpen={handleOpenType} />
        ),
        maxWidth: 55,
        colId: "srNo",
        pinned: isMobile ? false : true,
        editable: false,
        suppressClickEdit: true,
      },
      {
        headerName: "Sr No",
        field: "srNo",

        pinned: isMobile ? false : "left",
        minWidth: 65,
        maxWidth: 65,
        editable: false,
        editable: false,
        suppressClickEdit: true,
        filter: false,
        cellRenderer: (params) => {
          return params.node.rowIndex + 1;
        },

        cellStyle: (params) =>
          params?.data?.orderStatus === "HOLD" && {
            backgroundColor: theme.palette.warning.hold,
          },
      },

      {
        headerName: "AB Number",
        pinned: isMobile ? false : true,
        minWidth: 50,
        field: "abNumber",
        headerTooltip: "AB Number",
        cellEditor: CustomTextEditor,
        editable: false,
        // cellRenderer: showUpdatedAbNumber,
        cellStyle: (params) => {
          return (
            params?.data?.orderStatus === "HOLD" && {
              backgroundColor: theme.palette.warning.hold,
            }
          );
        },
      },
      {
        headerName: "Commission Name",
        pinned: isMobile ? false : true,
        field: "commissionName",
        headerTooltip: "Commission Name",
        minWidth: 215,
        cellRenderer: specialDiscountIcon,
        // cellStyle: { textAlign: "left" },
        editable: false,
        cellStyle: (params) => {
          return (
            params?.data?.orderStatus === "HOLD" && {
              backgroundColor: theme.palette.warning.hold,
              textAlign: "left",
            }
          );
        },
      },
      {
        headerName: "Unique ID",
        field: "uniqueId",
        headerTooltip: "Unique ID",
        minWidth: 50,
        editable: false,
        cellStyle: (params) => {
          return (
            params?.data?.orderStatus === "HOLD" && {
              backgroundColor: theme.palette.warning.hold,
            }
          );
        },
        valueFormatter: (params) => {
          return params.value ? params.value.toUpperCase() : params.value;
        },
      },
      {
        field: "orderStatus",
        headerName: "Status",
        headerTooltip: "Status",
        minWidth: 40,
        pinned: isMobile ? false : true,
        editable: false,
        filter: true,
        filter: "agMultiColumnFilter",

        valueGetter: (params) => {
          const value = params.data?.orderStatus;
          const amendment = params.data?.amendmentStatus;
          const abShareDate = params.data?.abShareDate;

          if (value === "AB_RECEIVED") {
            if (
              amendment === "AMENDMENT_REQUEST_FACTORY" ||
              amendment === "AMENDMENT_REQUEST_NFZE"
            ) {
              return amendment;
            } else {
              return abShareDate ? "AB_RECEIVED" : "ACK_FRM_FACTORY";
            }
          }

          return value;
        },

        cellRenderer: (props) => {
          const value = props.data?.orderStatus;
          const amendment = props.data?.amendmentStatus;
          const abShareDate = props.data?.abShareDate;

          let displayValue = value;

          if (value === "AB_RECEIVED") {
            if (
              amendment === "AMENDMENT_REQUEST_FACTORY" ||
              amendment === "AMENDMENT_REQUEST_NFZE"
            ) {
              displayValue = amendment;
            } else {
              displayValue = abShareDate ? "AB_RECEIVED" : "ACK_FRM_FACTORY";
            }
          }

          return <p>{displayValue}</p>;
        },

        cellClass: (params) => {
          const value = params.data?.orderStatus;
          const amendment = params.data?.amendmentStatus;
          const abShareDate = params.data?.abShareDate;

          if (value === "NEW") return "new";
          if (value === "ASSIGNED") return "assigned";
          if (value === "PLACED") return "placed";

          if (value === "AB_RECEIVED") {
            if (
              amendment === "AMENDMENT_REQUEST_FACTORY" ||
              amendment === "AMENDMENT_REQUEST_NFZE"
            ) {
              return "amendment";
            } else if (abShareDate) {
              return "ab_received";
            }
          }

          if (value === "INVOICED") return "invoiced";
          if (value === "IN_PROGRESS") return "inprogress";

          return null;
        },
      },
      {
        headerName: "ORDER CHARACTERISTICS",
        children: [
          {
            headerName: "Product / Vendor",
            field: "vendorShortKey",
            headerTooltip: "Product / Vendor",
            editable: false,
            minWidth: 60,
            cellEditor: SelectProduct,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Project Name",
            field: "projectName",
            headerTooltip: "projectName",
            minWidth: 65,
            editable: false,
            // rowGroup: true,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Project Phase",
            field: "phaseName",
            headerTooltip: "phaseName",
            minWidth: 65,
            editable: false,
            // rowGroup: true,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          { field: "vendorNum", hide: true, editable: false },
          { field: "vendorName", hide: true, editable: false },

          {
            headerName: "Document No",
            field: "documentNum",
            headerTooltip: "Document Number",
            minWidth: 65,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
          },
          {
            headerName: "Region / Zone",
            field: "region",
            headerTooltip: "Region / Zone",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Showroom / City",
            field: "showroomName",
            headerTooltip: "Showroom / City",
            minWidth: 150,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Created By",
            field: "createdByUser",
            headerTooltip: "Order Created By",
            minWidth: 150,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Order Type (SO/AO)",
            field: "documentType",
            headerTooltip: "Order Type (SO/AO)",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Category",
            field: "orderCategory",
            headerTooltip: "Category",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "No of Kitchen",
            field: "noOfKitchens",
            headerTooltip: "No of Kitchen",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },

          {
            headerName: "List Price WG1",
            field: "revisedLpWg1",
            headerTooltip: "List Price WG1",
            minWidth: 70,

            valueGetter: customListPriceWG1,
            cellRenderer: showFixedValue,
            cellEditor: CustomTextEditor,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "List price WG2",
            field: "revisedLpWg2",
            headerTooltip: "List price WG2",
            minWidth: 70,
            valueGetter: customListPriceWG2,
            cellRenderer: showFixedValue,
            cellEditor: CustomTextEditor,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Total List Price",
            field: "totalRevisedLpWg1Wg2",
            headerTooltip: "Total List Price",
            editable: false,
            minWidth: 70,
            cellRenderer: totalListPrice,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },

          { field: "range1Id", hide: true, editable: false },
          {
            headerName: "Range1",
            field: "range1",
            headerTooltip: "Range1",
            minWidth: 80,
            editable: false,
            cellEditor: SelectRange1,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Price Group1",
            field: "priceGroup1",
            headerTooltip: "Price Group",
            minWidth: 60,
            // cellStyle: { textAlign: "left" },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "color1Id", hide: true, editable: false },
          {
            headerName: "Front Color1",
            field: "color1",
            headerTooltip: "Front Color1",
            minWidth: 160,
            editable: false,
            cellEditor: SelectFrontColor1,
            cellRenderer: renderFrontColor,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "carcass1Id", hide: true, editable: false },
          {
            headerName: "Carcass1",
            field: "carcass1",
            headerTooltip: "Carcass1",
            minWidth: 160,
            editable: false,
            cellEditor: SelectCarcass,
            cellRenderer: renderCarcass,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "handle1Id", hide: true, editable: false },
          {
            headerName: "Handle1",
            field: "handle1",
            headerTooltip: "Handle1",
            minWidth: 160,
            editable: false,
            cellEditor: SelectHandle,
            cellRenderer: renderHandle,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "range2Id", hide: true, editable: false },
          {
            headerName: "Range2",
            field: "range2",
            headerTooltip: "Range2",
            minWidth: 80,
            editable: false,
            cellEditor: SelectRange2,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Price Group2",
            field: "priceGroup2",
            headerTooltip: "Price Group",
            minWidth: 60,
            // cellStyle: { textAlign: "left" },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "color2Id", hide: true, editable: false },
          {
            headerName: "Front Color2",
            field: "color2",
            headerTooltip: "Front Color2",
            minWidth: 160,
            editable: false,
            cellEditor: SelectFrontColor2,
            cellRenderer: renderFrontColor,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "carcass2Id", hide: true, editable: false },
          {
            headerName: "Carcass2",
            field: "carcass2",
            headerTooltip: "Carcass2",
            minWidth: 160,
            editable: false,
            cellEditor: SelectCarcass,
            cellRenderer: renderCarcass,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "handle2Id", hide: true, editable: false },
          {
            headerName: "Handle2",
            field: "handle2",
            headerTooltip: "Handle2",
            minWidth: 160,
            editable: false,
            cellEditor: SelectHandle,
            cellRenderer: renderHandle,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "range3Id", hide: true, editable: false },
          {
            headerName: "Range3",
            field: "range3",
            headerTooltip: "Range3",
            minWidth: 80,
            editable: false,
            cellEditor: SelectRange3,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Price Group3",
            field: "priceGroup3",
            headerTooltip: "Price Group",
            minWidth: 60,
            // cellStyle: { textAlign: "left" },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "color3Id", hide: true, editable: false },
          {
            headerName: "Front Color3",
            field: "color3",
            headerTooltip: "Front Color3",
            minWidth: 160,
            editable: false,
            cellEditor: SelectFrontColor3,
            cellRenderer: renderFrontColor,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "carcass3Id", hide: true, editable: false },
          {
            headerName: "Carcass3",
            field: "carcass3",
            headerTooltip: "Carcass3",
            minWidth: 160,
            editable: false,
            cellEditor: SelectCarcass,
            cellRenderer: renderCarcass,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "handle3Id", hide: true, editable: false },
          {
            headerName: "Handle3",
            field: "handle3",
            headerTooltip: "Handle3",
            minWidth: 160,
            editable: false,
            cellEditor: SelectHandle,
            cellRenderer: renderHandle,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
        ],
      },
      {
        headerName: "LOGISTICS",
        children: [
          {
            headerName: "Volume",
            field: "volume",
            headerTooltip: "Volume",
            minWidth: 90,
            // cellClass: "bg-logistics",
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : {
                    backgroundColor: "#7030a0",
                    color: "#fff",
                  };
            },
            editable: false,
            cellEditor: CustomTextEditor,
            cellRenderer: showFixedValue,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showLogistics,
          },
          {
            headerName: "Weight",
            field: "weight",
            headerTooltip: "Weight",
            minWidth: 90,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            cellEditor: CustomTextEditor,
            cellRenderer: showFixedValue,
            editable: false,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showLogistics,
          },
          {
            headerName: "No of Packs",
            field: "noOfPacks",
            headerTooltip: "No of Packs",
            minWidth: 60,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            editable: false,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showLogistics,
          },

          {
            headerName: "Internal Cont/ No",
            field: "internalContainerNo",
            headerTooltip: "Internal Cont/ No",
            minWidth: 60,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            editable: false,
            hide: !showLogistics,
          },

          {
            headerName: "Actual Cont/ No",
            field: "actualContainerNo",
            headerTooltip: "Actual Cont/ No",
            minWidth: 120,
            // cellStyle: {textAlign: 'left', backgroundColor: theme.palette.secondary.dark},
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7030a0",
                    color: "#fff",
                    textAlign: "left",
                  };
            },

            editable: false,
            hide: !showLogistics,
          },

          {
            headerName: "Port",
            field: "port",
            headerTooltip: "Port",
            minWidth: 60,
            // cellStyle: {textAlign: 'left', backgroundColor: theme.palette.secondary.dark},
            // cellStyle: { textAlign: "left" },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7030a0",
                    color: "#fff",
                    textAlign: "left",
                  };
            },
            hide: !showLogistics,
          },
          {
            headerName: "Mode of Shipping",
            field: "freightId",
            headerTooltip: "Mode of Shipping",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            cellEditor: SelectShippingType,
            hide: !showLogistics,
          },
          {
            headerName: "Tour No",
            field: "tourNo",
            headerTooltip: "Tour No",
            minWidth: 60,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            editable: false,
            hide: !showLogistics,
          },
        ],
      },

      {
        headerName: "HISTORY",
        children: [
          {
            headeName: "Order Created Date",
            field: "createdDate",
            headerTooltip: "Order Created Date",
            minWidth: 120,
            // cellClass: "history",
            // cellStyle: { backgroundColor: theme.palette.warning.dark},
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            editable: false,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },

          {
            headerName: "Order Placed Date",
            field: "orderPlacedDate",
            headerTooltip: "Order Placed Date",
            minWidth: 120,
            // cellClass: "history",
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.warning.dark},
            cellRenderer: handleDateFormat,
            editable: false,
            cellEditor: SelectDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },

          {
            headerName: "AB Received Date",
            field: "abReceivedDate",
            headerTooltip: "AB Received Date",
            minWidth: 120,
            editable: false,
            // cellClass: "history",
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.warning.dark},
            cellRenderer: handleDateFormat,
            cellEditor: SelectDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Confirmed Date",
            field: "orderConfirmedDate",
            headerTooltip: "Confirmed Date",
            editable: false,
            minWidth: 120,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            // cellClass: "history",
            // cellStyle: { backgroundColor: theme.palette.warning.dark},
            cellRenderer: handleDateFormat,
            cellEditor: SelectDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Loading Plan Date",
            field: "plannedLoadingDate",
            headerTooltip: "Loading Plan Date",
            minWidth: 120,
            editable: false,
            // cellClass: "history",
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.warning.dark},
            cellRenderer: handleDateFormat,
            cellEditor: PlannedLoadingDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Loading Plan Week",
            field: "plannedLoadingWeek",
            headerTooltip: "Loading Plan Week",
            minWidth: 80,
            editable: false,
            // cellClass: "history",
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.warning.dark},
            cellEditor: PlannedLoadingWeek,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showHistory,
          },
          {
            headerName: "Cut off Date",
            field: "cutoffDate",
            headerTooltip: "Cut off Date",
            minWidth: 120,
            // cellClass: "history",
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.warning.dark},
            cellRenderer: handleDateFormat,
            cellEditor: SelectDate,
            editable: false,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Release date",
            field: "releaseDate",
            headerTooltip: "Release date",
            minWidth: 80,
            // cellClass: "history",
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.warning.dark},
            cellRenderer: handleDateFormat,
            editable: false,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Actual Loading Date",
            field: "actualLoadingDate",
            headerTooltip: "Actual Loading Date",
            minWidth: 120,
            editable: false,
            // cellClass: "history",
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.warning.dark},
            cellRenderer: handleDateFormat,
            cellEditor: ActualLoadingDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Actual Loading week",
            field: "actualLoadingWeek",
            editable: false,
            headerTooltip: "Actual Loading week",
            minWidth: 80,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            // cellClass: "history",
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.warning.dark},
            cellEditor: ActualLoadingWeek,
            hide: !showHistory,
          },
        ],
      },
    ],
    otherRoleCol: [
      {
        //select all option in OMS
        headerName: "Sr No",
        field: "srNo",
        colId: "srNo",
        pinned: isMobile ? false : "left",
        minWidth: 65,
        maxWidth: 65,
        editable: false,
        filter: false,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        cellRenderer: (params) => {
          return params.node.rowIndex + 1;
        },

        cellStyle: (params) =>
          params?.data?.orderStatus === "HOLD" && {
            backgroundColor: theme.palette.warning.hold,
          },
      },

      {
        headerName: "AB Number",
        pinned: isMobile ? false : true,
        minWidth: 50,
        field: "abNumber",
        headerTooltip: "AB Number",
        cellEditor: CustomTextEditor,
        // cellRenderer: showUpdatedAbNumber,
        cellStyle: (params) => {
          return (
            params?.data?.orderStatus === "HOLD" && {
              backgroundColor: theme.palette.warning.hold,
            }
          );
        },
      },
      {
        headerName: "Commission Name",
        pinned: isMobile ? false : true,
        field: "commissionName",
        headerTooltip: "Commission Name",
        minWidth: 215,
        cellRenderer: specialDiscountIcon,
        // cellStyle: { textAlign: "left" },
        editable: false,
        cellStyle: (params) => {
          return (
            params?.data?.orderStatus === "HOLD" && {
              backgroundColor: theme.palette.warning.hold,
              textAlign: "left",
            }
          );
        },
      },

      {
        headerName: "Status",
        //  pinned: isMobile ? false : true,
        pinned: isMobile ? false : "left",
        field: "orderStatus",
        headerTooltip: "Status",
        minWidth: 40,
        editable: false,

        cellRenderer: (props) => {
          const value = props.value;
          const amendment = props?.data?.amendmentStatus;

          if (
            (value === "AB_RECEIVED" || value === "UNDER_CONFIRMATION") &&
            (amendment === "AMENDMENT_REQUEST_FACTORY" ||
              amendment === "AMENDMENT_REQUEST_NFZE")
          ) {
            return <p>{amendment}</p>;
          } else {
            return <p>{value}</p>;
          }
        },

        valueGetter: (params) => {
          const value = params.data?.orderStatus;
          const amendment = params.data?.amendmentStatus;

          if (
            (value === "AB_RECEIVED" || value === "UNDER_CONFIRMATION") &&
            (amendment === "AMENDMENT_REQUEST_FACTORY" ||
              amendment === "AMENDMENT_REQUEST_NFZE")
          ) {
            return amendment;
          }

          return value;
        },

        filter: "agMultiColumnFilter",

        cellStyle: (params) => {
          return (
            params?.data?.orderStatus === "HOLD" && {
              backgroundColor: theme.palette.warning.hold,
            }
          );
        },
      },

      {
        headerName: "Unique ID",
        field: "uniqueId",
        pinned: isMobile ? false : "left",
        //  pinned: isMobile ? false : true,
        headerTooltip: "Unique ID",
        minWidth: 50,
        cellEditor: UniqueIdEditor,
        cellEditorParams: {
          onLiveChange: handleUniqueIdLiveChange,
        },
        cellStyle: (params) => {
          return (
            params?.data?.orderStatus === "HOLD" && {
              backgroundColor: theme.palette.warning.hold,
            }
          );
        },
        valueFormatter: (params) => {
          return params.value ? params.value.toUpperCase() : params.value;
        },
      },
      {
        headerName: "ORDER CHARACTERISTICS",
        children: [
          {
            headerName: "Product / Vendor",
            field: "vendorShortKey",
            headerTooltip: "Product / Vendor",
            minWidth: 60,
            cellEditor: SelectProduct,
            editable: false,
            // rowGroup: true,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Project Name",
            field: "projectName",
            headerTooltip: "projectName",
            minWidth: 65,
            editable: false,
            // rowGroup: true,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Project Phase",
            field: "phaseName",
            headerTooltip: "phaseName",
            minWidth: 65,
            editable: false,
            // rowGroup: true,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          { field: "vendorNum", hide: true, editable: false },
          { field: "vendorName", hide: true, editable: false },
          {
            headerName: "Customer",
            field: "customerName",
            headerTooltip: "Customer",
            minWidth: 65,
            editable: false,
            // rowGroup: true,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Country",
            field: "country",
            headerTooltip: "Country",
            minWidth: 65,
            editable: false,
            // rowGroup: true,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Document No",
            field: "documentNum",
            headerTooltip: "Document Number",
            minWidth: 65,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Territory",
            field: "territory",
            headerTooltip: "Territory",
            minWidth: 60,
            // rowGroup: true,
            cellRenderer: (props) => {
              if (props?.value) {
                return <div>{`${props?.value}`}</div>;
              }
            },
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
            valueGetter: (params) => {
              const value = params.data?.territory;

              return `T${value}`;
            },

            filter: "agMultiColumnFilter",
          },
          {
            headerName: "Region / Zone",
            field: "region",
            headerTooltip: "Region / Zone",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Showroom / City",
            field: "showroomName",
            headerTooltip: "Showroom / City",
            minWidth: 150,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Order Type (SO/AO)",
            field: "documentType",
            headerTooltip: "Order Type (SO/AO)",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Category",
            field: "orderCategory",
            headerTooltip: "Category",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Canias Doc Num",
            field: "caniasDocNum",
            headerTooltip: "Canias Document Number",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Created By",
            field: "createdByUser",
            headerTooltip: "Order Created By",
            minWidth: 150,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Assigned To",
            field: "assignedTo",
            headerTooltip: "Order Assigned To",
            minWidth: 150,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "No/ of Kitchen",
            field: "noOfKitchens",
            headerTooltip: "No/ of Kitchen",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "No/of Furniture",
            field: "noOfFurniture",
            headerTooltip: "No/of Furniture",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "No/ of Spa",
            field: "noOfSpaItems",
            headerTooltip: "No/ of Spa",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "No/ of Living",
            field: "noOfLivingRmItems",
            headerTooltip: "No/ of Living",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "List Price WG1",
            field: "revisedLpWg1",
            headerTooltip: "List Price WG1",
            minWidth: 70,
            valueGetter: customListPriceWG1,
            cellEditor: CustomTextEditor,
            cellEditorParams: { isNumeric: true },

            cellRenderer: showFixedValue,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "List price WG2",
            field: "revisedLpWg2",
            headerTooltip: "List price WG2",
            minWidth: 70,
            valueGetter: customListPriceWG2,
            cellEditor: CustomTextEditor,
            cellEditorParams: { isNumeric: true },

            cellRenderer: showFixedValue,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Total List Price",
            field: "totalRevisedLpWg1Wg2",
            headerTooltip: "Total List Price",
            editable: false,
            minWidth: 70,
            cellRenderer: totalListPrice,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Hubspot Reference",
            field: "hubspotReference",
            headerTooltip: "Hubspot Reference",
            minWidth: 70,
            // cellRenderer: showFixedValue,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Hubspot RCBL",
            field: "hubspotRcbl",
            headerTooltip: "Hubspot RCBL",
            minWidth: 100,
            // cellRenderer: showFixedValue,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },

          { field: "range1Id", hide: true, editable: false },
          {
            headerName: "Range1",
            field: "range1",
            headerTooltip: "Range1",
            minWidth: 80,
            editable: true,
            cellEditor: SelectRange1,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Price Group1",
            field: "priceGroup1",
            headerTooltip: "Price Group",
            minWidth: 60,
            // cellStyle: { textAlign: "left" },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "color1Id", hide: true, editable: false },
          {
            headerName: "Front Color1",
            field: "color1",
            headerTooltip: "Front Color1",
            minWidth: 160,
            cellEditor: SelectFrontColor1,
            cellRenderer: renderFrontColor,
            cellEditorParams: {
              onValidityChange: handleColorValidityChange,
            },
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "carcass1Id", hide: true, editable: false },
          {
            headerName: "Carcass1",
            field: "carcass1",
            headerTooltip: "Carcass1",
            minWidth: 160,
            cellEditor: SelectCarcass,
            cellRenderer: renderCarcass,
            // cellStyle: { textAlign: "left" },
            cellEditorParams: { onValidityChange: handleColorValidityChange },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "handle1Id", hide: true, editable: false },
          {
            headerName: "Handle1",
            field: "handle1",
            headerTooltip: "Handle1",
            minWidth: 160,
            cellEditor: SelectHandle,
            cellRenderer: renderHandle,
            cellEditorParams: { onValidityChange: handleColorValidityChange },
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "range2Id", hide: true, editable: false },
          {
            headerName: "Range2",
            field: "range2",
            headerTooltip: "Range2",
            minWidth: 80,
            editable: true,
            cellEditor: SelectRange2,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Price Group2",
            field: "priceGroup2",
            headerTooltip: "Price Group",
            minWidth: 60,
            // cellStyle: { textAlign: "left" },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "color2Id", hide: true, editable: false },
          {
            headerName: "Front Color2",
            field: "color2",
            headerTooltip: "Front Color2",
            minWidth: 160,
            cellEditor: SelectFrontColor2,
            cellEditorParams: {
              onValidityChange: handleColorValidityChange,
            },
            cellRenderer: renderFrontColor,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "carcass2Id", hide: true, editable: false },
          {
            headerName: "Carcass2",
            field: "carcass2",
            headerTooltip: "Carcass2",
            minWidth: 160,
            cellEditor: SelectCarcass,
            cellEditorParams: { onValidityChange: handleColorValidityChange },
            cellRenderer: renderCarcass,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "handle2Id", hide: true, editable: false },
          {
            headerName: "Handle2",
            field: "handle2",
            headerTooltip: "Handle2",
            minWidth: 160,
            cellEditor: SelectHandle,
            cellEditorParams: { onValidityChange: handleColorValidityChange },
            cellRenderer: renderHandle,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "range3Id", hide: true, editable: false },
          {
            headerName: "Range3",
            field: "range3",
            headerTooltip: "Range3",
            minWidth: 80,
            editable: true,
            cellEditor: SelectRange3,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Price Group3",
            field: "priceGroup3",
            headerTooltip: "Price Group",
            minWidth: 60,
            // cellStyle: { textAlign: "left" },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                    color: "#fff",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "color3Id", hide: true, editable: false },
          {
            headerName: "Front Color3",
            field: "color3",
            headerTooltip: "Front Color3",
            minWidth: 160,
            cellEditor: SelectFrontColor3,
            cellRenderer: renderFrontColor,
            cellEditorParams: {
              onValidityChange: handleColorValidityChange,
            },
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "carcass3Id", hide: true, editable: false },
          {
            headerName: "Carcass3",
            field: "carcass3",
            headerTooltip: "Carcass3",
            minWidth: 160,
            cellEditor: SelectCarcass,
            cellEditorParams: { onValidityChange: handleColorValidityChange },
            cellRenderer: renderCarcass,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "handle3Id", hide: true, editable: false },
          {
            headerName: "Handle3",
            field: "handle3",
            headerTooltip: "Handle3",
            minWidth: 160,
            cellEditor: SelectHandle,
            cellEditorParams: { onValidityChange: handleColorValidityChange },
            cellRenderer: renderHandle,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
        ],
      },
      {
        headerName: "LOGISTICS",
        children: [
          {
            headerName: "Volume",
            field: "volume",
            headerTooltip: "Volume",
            minWidth: 90,
            // cellClass: "bg-logistics",
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            cellEditor: CustomTextEditor,
            cellEditorParams: { isNumeric: true },

            cellRenderer: showFixedValue,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showLogistics,
          },
          {
            headerName: "Weight",
            field: "weight",
            headerTooltip: "Weight",
            minWidth: 90,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            cellEditor: CustomTextEditor,
            cellEditorParams: { isNumeric: true },

            cellRenderer: showFixedValue,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showLogistics,
          },
          {
            headerName: "No of Packs",
            field: "noOfPacks",
            headerTooltip: "No of Packs",
            minWidth: 60,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            editable: false,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showLogistics,
          },
          {
            headerName: "Internal Cont/ No",
            field: "internalContainerNo",
            headerTooltip: "Internal Cont/ No",
            minWidth: 60,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            editable: false,
            hide: !showLogistics,
          },
          {
            headerName: "Actual Cont/ No",
            field: "actualContainerNo",
            headerTooltip: "Actual Cont/ No",
            minWidth: 120,
            // cellStyle: {textAlign: 'left', backgroundColor: theme.palette.secondary.dark},
            // cellStyle: {  textAlign: "left"},
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7030a0",
                    color: "#fff",
                    textAlign: "left",
                  };
            },
            editable: false,
            hide: !showLogistics,
          },
          {
            headerName: "Port",
            field: "port",
            headerTooltip: "Port",
            minWidth: 60,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7030a0",
                    color: "#fff",
                    textAlign: "left",
                  };
            },
            // cellStyle: {textAlign: 'left', backgroundColor: theme.palette.secondary.dark},
            editable: false,
            hide: !showLogistics,
          },
          {
            headerName: "Mode of Shipping",
            field: "freightId",
            headerTooltip: "Mode of Shipping",
            minWidth: 60,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            cellEditor: SelectShippingType,
            hide: !showLogistics,
          },
          {
            headerName: "Tour No",
            field: "tourNo",
            headerTooltip: "Tour No",
            minWidth: 60,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            editable: false,
            hide: !showLogistics,
          },
        ],
      },
      {
        headerName: "COMMERCIAL (RCBL)",
        children: [
          {
            headerName: "Slab Number",
            field: "slabNum",
            headerTooltip: "Slab Number",
            minWidth: 60,

            cellRenderer: (params) => {
              const value = params.value;

              if (value === 0) return "0";
              if (value === null || value === undefined || value === "")
                return "";

              return value;
            },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#fff",
                  };
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "Receivable",
            field: "grandTotal",
            headerTooltip: "Receivable",
            minWidth: 60,
            cellRenderer: showDiscountPercentMoney,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#fff",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "WG1 Price Inc",
            field: "wg1PriceIncrease",
            headerTooltip: "WG1 Price Increase",
            minWidth: 60,

            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#fff",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "WG2 Price Inc",
            field: "wg2PriceIncrease",
            headerTooltip: "WG2 Price Increase",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#fff",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },

          {
            headerName: "After WG1 Price Inc",
            field: "afterPriceIncreaseWg1",
            headerTooltip: "After WG1 Price Increase",
            minWidth: 60,
            cellRenderer: showDiscountPercentMoney,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#fff",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "After WG2 Price Inc",
            field: "afterPriceIncreaseWg2",
            headerTooltip: "After WG2 Price Increase",
            minWidth: 60,
            cellRenderer: showDiscountPercentMoney,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#fff",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },

          {
            headerName: "Std Disc/ WG1",
            field: "stdDiscWg1",
            headerTooltip: "Std Disc/ WG1",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#fff",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "Spl Disc/ WG1",
            field: "splDiscWg1",
            headerTooltip: "Spl Disc/ WG1",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            cellEditor: CustomTextEditor,
            cellEditorParams: { isNumeric: true },

            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#fff",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "SDR WG1",
            field: "sdrWg1",
            headerTooltip: "SDR WG1",
            cellRenderer: showDiscountPercent,
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#fff",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "PDR WG1",
            field: "promoDiscWg1",
            headerTooltip: "PDR WG1 (Approved in Disc/ Master)",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#fff",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "Cum  Disc/ WG1",
            field: "totalDiscWg1",
            headerTooltip: "Cum  Disc/ WG1",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#fff",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },

          {
            headerName: "Std Disc/ WG2",
            field: "stdDiscWg2",
            headerTooltip: "Std Disc/ WG2",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#FFF9C4",
                    fontWeight: "600",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "Spl Disc/ WG2",
            field: "splDiscWg2",
            headerTooltip: "Spl Disc/ WG2 (Authorized access)",
            minWidth: 60,
            cellEditor: CustomTextEditor,
            cellEditorParams: { isNumeric: true },

            cellRenderer: showDiscountPercent,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#FFF9C4",
                    fontWeight: "600",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "SDR WG2",
            field: "sdrWg2",
            headerTooltip: "SDR WG2 (Through Approval)",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#FFF9C4",
                    fontWeight: "600",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "PDR WG2",
            field: "promoDiscWg2",
            headerTooltip: "PDR WG2 (Approved in Disc/ Master)",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#FFF9C4",
                    fontWeight: "600",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "Cum  Disc/ WG2",
            field: "totalDiscWg2",
            headerTooltip: "Cum  Disc/ WG2",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#FFF9C4",
                    fontWeight: "600",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },

          {
            headerName: "Margin",
            field: "netPayDiff",
            headerTooltip: "Margin",
            minWidth: 60,
            cellRenderer: (params) => {
              const grandTotal = Number(params?.data?.grandTotal) || 0;
              const netPayable = Number(params?.data?.netPayable) || 0;

              const margin =
                grandTotal && netPayable ? grandTotal - netPayable : 0;

              return showFixedValue({ ...params, value: margin });
            },
            editable: false,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellStyle: (params) => ({
              textAlign: "right",
              backgroundColor:
                params?.data?.orderStatus === "HOLD"
                  ? theme.palette.warning.hold
                  : "#0070C0",
              color:
                params?.data?.orderStatus === "HOLD"
                  ? theme.palette.warning.contrastText
                  : theme.palette.common.white,
            }),
            hide: !showCommercialRcbl,
          },
          {
            headerName: "Gesture to Customer",
            field: "totalDiscWg1Wg2",
            headerTooltip: "Gesture to Customer",
            minWidth: 60,
            valueGetter: (params) => {
              const row = params.data || {};

              const wg1Gesture =
                Number(row.afterSplDiscWg1) - Number(row.afterSdrWg1);
              const wg2Gesture =
                Number(row.afterSplDiscWg2) - Number(row.afterSdrWg2);
              const gesture = wg1Gesture + wg2Gesture;

              return gesture;
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellRenderer: showFixedValue,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#0070C0", color: "#fff" };
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "PI Status",
            field: "proformaStatus",
            minWidth: 70,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#0070C0", color: "#fff" };
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "PI No",
            field: "proformaNo",
            minWidth: 70,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#0070C0", color: "#fff" };
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "PI Date",
            field: "proformaDate",
            minWidth: 80,
            cellRenderer: handleDateFormat,
            filter: "agDateColumnFilter",
            filterParams,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#0070C0", color: "#fff" };
            },
            hide: !showCommercialRcbl,
          },
        ],
      },
      {
        headerName: "COMMERCIAL (PBL)",
        children: [
          {
            headerName: "Slab Number",
            field: "vendorSlabNo",
            headerTooltip: "Slab Number",
            minWidth: 60,
            cellRenderer: (params) => {
              const value = params.value;

              if (value === 0) return "0";
              if (value === null || value === undefined || value === "")
                return "";

              return value;
            },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "Payable",
            field: "netPayable",
            headerTooltip: "Payable",
            minWidth: 60,
            cellRenderer: showDiscountPercentMoney,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "WG1 Price Inc",
            field: "wg1PriceIncreasePayable",
            headerTooltip: "WG1 Price Increase",
            cellRenderer: showDiscountPercent,
            minWidth: 60,
            editable: false,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "WG2 Price Inc",
            field: "wg2PriceIncreasePayable",
            headerTooltip: "WG2 Price Increase",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            hide: !showCommercialPbl,
          },

          {
            headerName: "After WG1 Price Inc",
            field: "payableAfterWg1PriceIncrease",
            headerTooltip: "After WG1 Price Increase",
            minWidth: 60,
            cellRenderer: showDiscountPercentMoney,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "After WG2 Price Inc",
            field: "payableAfterWg2PriceIncrease",
            headerTooltip: "After WG2 Price Increase",
            minWidth: 60,
            cellRenderer: showDiscountPercentMoney,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialPbl,
          },

          {
            headerName: "Std Disc/ WG1",
            field: "stdDiscWG1Payable",
            headerTooltip: "Std Disc/ WG1",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "Spl Disc/ WG1",
            field: "splDiscWG1Payable",
            headerTooltip: "Spl Disc/ WG1 (Authorized access)",
            minWidth: 60,
            cellEditor: CustomTextEditor,
            cellEditorParams: { isNumeric: true },

            cellRenderer: showDiscountPercent,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "SDP WG1",
            field: "sdpWg1",
            headerTooltip: "SDP WG1 (Through Approval)",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "PDP WG1",
            field: "promoDiscWg1Payable",
            headerTooltip: "PDP WG1 (Approved in Disc/ Master)",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "Cum  Disc/ WG1",
            field: "totalDiscWG1Payable",
            headerTooltip: "Cum  Disc/ WG1",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            hide: !showCommercialPbl,
          },

          {
            headerName: "Std Disc/ WG2",
            field: "stdDiscWG2Payable",
            headerTooltip: "Std Disc/ WG2",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#2f765f",
                    color: "#FFF9C4",
                    fontWeight: "600",
                  };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "Spl Disc/ WG2",
            field: "splDiscWG2Payable",
            headerTooltip: "",
            minWidth: 60,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellEditor: CustomTextEditor,
            cellEditorParams: { isNumeric: true },

            cellRenderer: showDiscountPercent,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#2f765f",
                    color: "#FFF9C4",
                    fontWeight: "600",
                  };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "SDP WG2",
            field: "sdpWg2",
            headerTooltip: "SDP WG2 (Authorized access)",
            minWidth: 60,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#2f765f",
                    color: "#FFF9C4",
                    fontWeight: "600",
                  };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "PDP WG2",
            field: "promoDiscWg2Payable",
            headerTooltip: "PDP WG2 (Approved in Disc/ Master)",
            minWidth: 60,
            cellRenderer: showDiscountPercent,
            editable: false,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#2f765f",
                    color: "#FFF9C4",
                    fontWeight: "600",
                  };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "Cum  Disc/ WG2",
            field: "totalDiscWG2Payable",
            headerTooltip: "Cum  Disc/ WG2",
            minWidth: 60,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#2f765f",
                    color: "#FFF9C4",
                    fontWeight: "600",
                  };
            },
            hide: !showCommercialPbl,
          },

          {
            headerName: "Gesture from Vendor",
            field: "totalDiscWg1Wg2Payable",
            headerTooltip: "Gesture from Vendor",
            minWidth: 60,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellRenderer: showFixedValue,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            valueGetter: (params) => {
              const row = params.data || {};

              const wg1Gesture =
                Number(row.afterSplDiscWG1Payable) - Number(row.afterSdpWg1);
              const wg2Gesture =
                Number(row.afterSplDiscWG2Payable) - Number(row.afterSdpWg2);
              const gesture = wg1Gesture + wg2Gesture;

              return gesture;
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "Transfer DISC WG1",
            field: "transferDiscountWg1",
            headerTooltip: "Transfer Discount WG1",
            minWidth: 60,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "Transfer DISC WG2",
            field: "transferDiscountWg2",
            headerTooltip: "Transfer Discount WG2",
            minWidth: 60,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "PBL after Transfer DISC ",
            field: "payableAfterTransferDiscountWg1Wg2",
            headerTooltip: "Payable after Transfer Discount",
            minWidth: 60,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellRenderer: showDiscountPercentMoney,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "German VAT %",
            field: "germanVatPercent",
            headerTooltip: "German Vat",
            minWidth: 60,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellRenderer: showDiscountPercent,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "German VAT",
            field: "germanVatAmt",
            headerTooltip: "German Vat",
            minWidth: 60,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellRenderer: showFixedValue,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "PBL after VAT",
            field: "payableAfterGermanVat",
            headerTooltip: "Payable after German VAT",
            minWidth: 60,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellRenderer: showDiscountPercentMoney,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "PI Amount",
            field: "netPurchaseInvAmt",
            headerTooltip: "Net purchase Invoice Amount",
            minWidth: 60,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellRenderer: showDiscountPercentMoney,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "Pay Difference",
            field: "netPayDiff",
            headerTooltip: "Net Pay Difference",
            minWidth: 60,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellRenderer: showDiscountPercentMoney,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            hide: !showCommercialPbl,
          },
          {
            headerName: "Reconciled",
            field: "netReconciled",
            minWidth: 60,
            editable: false,
            cellRenderer: (props) => {
              const value = props?.value;
              if (value === "Yes") {
                return <p>Yes</p>;
              } else {
                return <p>No</p>;
              }
            },
            valueGetter: (params) => {
              const value = params?.data?.netReconciled;
              if (value) {
                return "Yes";
              }
              return "No";
            },
            filter: "agMultiColumnFilter",

            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },

            hide: !showCommercialPbl,
          },
        ],
      },
      {
        headerName: "HISTORY",
        children: [
          {
            headerName: "Order Received Date",
            field: "createdDate",
            headerTooltip: "Order Received Date",
            minWidth: 120,
            cellClass: "history",
            cellRenderer: handleDateFormat,
            editable: false,
            filter: "agDateColumnFilter",
            filterParams,

            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            hide: !showHistory,
          },
          {
            headerName: "Order Placed Date",
            field: "orderPlacedDate",
            headerTooltip: "Order Placed Date",
            minWidth: 120,
            // cellClass: "history",
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            cellEditor: SelectDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "AB Received Date",
            field: "abReceivedDate",
            headerTooltip: "AB Received Date",
            minWidth: 120,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            cellEditor: SelectDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Confirmed Date",
            field: "orderConfirmedDate",
            headerTooltip: "Confirmed Date",
            minWidth: 120,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            cellEditor: SelectDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Loading Plan Date",
            field: "plannedLoadingDate",
            headerTooltip: "Loading Plan Date",
            minWidth: 120,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            filter: "agDateColumnFilter",
            filterParams,
            cellEditor: PlannedLoadingDate,
            hide: !showHistory,
          },
          {
            headerName: "Loading Plan Week",
            field: "plannedLoadingWeek",
            headerTooltip: "Loading Plan Week",
            minWidth: 80,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellEditor: PlannedLoadingWeek,
            hide: !showHistory,
          },
          {
            headerName: "Cut off Date",
            field: "cutoffDate",
            headerTooltip: "Cut off Date",
            minWidth: 120,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            filter: "agDateColumnFilter",
            filterParams,
            cellEditor: SelectDate,
            hide: !showHistory,
          },
          {
            headerName: "Release date",
            field: "releaseDate",
            headerTooltip: "Release date",
            minWidth: 80,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            editable: false,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Actual Loading Date",
            field: "actualLoadingDate",
            headerTooltip: "Actual Loading Date",
            minWidth: 120,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            cellEditor: ActualLoadingDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Actual Loading week",
            field: "actualLoadingWeek",
            headerTooltip: "Actual Loading week",
            minWidth: 80,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellEditor: ActualLoadingWeek,
            hide: !showHistory,
          },
        ],
      },
      {
        headerName: "APPROVALS",
        children: [
          {
            headerName: "SDR Status",
            field: "sdrStatus",
            headerTooltip: "SDR Status",
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#b276df", color: "#fff" };
            },
            minWidth: 90,
            hide: !showApprovals,
          },
          {
            headerName: "SDP Status",
            field: "sdpStatus",
            headerTooltip: "SDP Status",
            editable: false,

            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#b276df", color: "#fff" };
            },
            minWidth: 90,
            hide: !showApprovals,
          },
          {
            headerName: "Approval for booking",
            field: "bookingStatus",
            headerTooltip: "Approval for booking",

            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#b276df", color: "#fff" };
            },
            minWidth: 90,
            editable: false,
            hide: !showApprovals,
          },
          {
            headerName: "Approval to Release",
            field: "releaseStatus",
            headerTooltip: "Approval to Release",

            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#b276df", color: "#fff" };
            },

            minWidth: 90,
            editable: false,
            hide: !showApprovals,
          },
          {
            headerName: "Skip promotion",
            field: "skipPromotion",
            headerTooltip: "Skip promotion",

            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#b276df", color: "#fff" };
            },
            cellRenderer: ActiveSwitch,
            minWidth: 90,
            editable: false,
            hide: !showApprovals,
          },
        ],
      },
    ],
    logisticsRoleCol: [
      {
        headerName: "Sr No",
        field: "srNo",
        colId: "srNo",
        pinned: isMobile ? false : "left",
        minWidth: 65,
        maxWidth: 65,
        editable: false,
        filter: false,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        cellRenderer: (params) => {
          return params.node.rowIndex + 1;
        },

        cellStyle: (params) =>
          params?.data?.orderStatus === "HOLD" && {
            backgroundColor: theme.palette.warning.hold,
          },
      },

      {
        headerName: "AB Number",
        pinned: isMobile ? false : true,
        minWidth: 50,
        field: "abNumber",
        headerTooltip: "AB Number",
        editable: false,
        cellEditor: CustomTextEditor,
        // cellRenderer: showUpdatedAbNumber,
        cellStyle: (params) => {
          return (
            params?.data?.orderStatus === "HOLD" && {
              backgroundColor: theme.palette.warning.hold,
            }
          );
        },
      },
      {
        headerName: "Commission Name",
        pinned: isMobile ? false : true,
        field: "commissionName",
        headerTooltip: "Commission Name",
        minWidth: 215,
        cellRenderer: specialDiscountIcon,
        // cellStyle: { textAlign: "left" },
        editable: false,
        cellStyle: (params) => {
          return (
            params?.data?.orderStatus === "HOLD" && {
              backgroundColor: theme.palette.warning.hold,
              textAlign: "left",
            }
          );
        },
      },

      {
        headerName: "Status",
        //  pinned: isMobile ? false : true,
        pinned: isMobile ? false : "left",
        field: "orderStatus",
        headerTooltip: "Status",
        minWidth: 40,
        editable: false,

        cellRenderer: (props) => {
          const value = props.value;
          const amendment = props?.data?.amendmentStatus;

          if (
            (value === "AB_RECEIVED" || value === "UNDER_CONFIRMATION") &&
            (amendment === "AMENDMENT_REQUEST_FACTORY" ||
              amendment === "AMENDMENT_REQUEST_NFZE")
          ) {
            return <p>{amendment}</p>;
          } else {
            return <p>{value}</p>;
          }
        },

        valueGetter: (params) => {
          const value = params.data?.orderStatus;
          const amendment = params.data?.amendmentStatus;

          if (
            (value === "AB_RECEIVED" || value === "UNDER_CONFIRMATION") &&
            (amendment === "AMENDMENT_REQUEST_FACTORY" ||
              amendment === "AMENDMENT_REQUEST_NFZE")
          ) {
            return amendment;
          }

          return value;
        },

        filter: "agMultiColumnFilter",

        cellStyle: (params) => {
          return (
            params?.data?.orderStatus === "HOLD" && {
              backgroundColor: theme.palette.warning.hold,
            }
          );
        },
      },

      {
        headerName: "Unique ID",
        field: "uniqueId",
        pinned: isMobile ? false : "left",
        //  pinned: isMobile ? false : true,
        headerTooltip: "Unique ID",
        minWidth: 50,
        cellEditor: UniqueIdEditor,
        editable: false,
        cellEditorParams: {
          onLiveChange: handleUniqueIdLiveChange,
        },
        cellStyle: (params) => {
          return (
            params?.data?.orderStatus === "HOLD" && {
              backgroundColor: theme.palette.warning.hold,
            }
          );
        },
        valueFormatter: (params) => {
          return params.value ? params.value.toUpperCase() : params.value;
        },
      },
      {
        headerName: "ORDER CHARACTERISTICS",
        children: [
          {
            headerName: "Product / Vendor",
            field: "vendorShortKey",
            headerTooltip: "Product / Vendor",
            minWidth: 60,
            cellEditor: SelectProduct,
            editable: false,
            // rowGroup: true,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Project Name",
            field: "projectName",
            headerTooltip: "projectName",
            minWidth: 65,
            editable: false,
            // rowGroup: true,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Project Phase",
            field: "phaseName",
            headerTooltip: "phaseName",
            minWidth: 65,
            editable: false,
            // rowGroup: true,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          { field: "vendorNum", hide: true, editable: false },
          { field: "vendorName", hide: true, editable: false },
          {
            headerName: "Customer",
            field: "customerName",
            headerTooltip: "Customer",
            minWidth: 65,
            editable: false,
            // rowGroup: true,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Country",
            field: "country",
            headerTooltip: "Country",
            minWidth: 65,
            editable: false,
            // rowGroup: true,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Document No",
            field: "documentNum",
            headerTooltip: "Document Number",
            minWidth: 65,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Territory",
            field: "territory",
            headerTooltip: "Territory",
            minWidth: 60,
            // rowGroup: true,
            cellRenderer: (props) => {
              if (props?.value) {
                return <div>{`${props?.value}`}</div>;
              }
            },
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
            valueGetter: (params) => {
              const value = params.data?.territory;

              return `T${value}`;
            },

            filter: "agMultiColumnFilter",
          },
          {
            headerName: "Region / Zone",
            field: "region",
            headerTooltip: "Region / Zone",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Showroom / City",
            field: "showroomName",
            headerTooltip: "Showroom / City",
            minWidth: 150,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Order Type (SO/AO)",
            field: "documentType",
            headerTooltip: "Order Type (SO/AO)",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Category",
            field: "orderCategory",
            headerTooltip: "Category",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Canias Doc Num",
            field: "caniasDocNum",
            headerTooltip: "Canias Document Number",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Created By",
            field: "createdByUser",
            headerTooltip: "Order Created By",
            minWidth: 150,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Assigned To",
            field: "assignedTo",
            headerTooltip: "Order Assigned To",
            minWidth: 150,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "No/ of Kitchen",
            field: "noOfKitchens",
            headerTooltip: "No/ of Kitchen",
            minWidth: 60,
            editable: false,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            hide: !showOrderCharacteristics,
          },

          {
            headerName: "List Price WG1",
            field: "revisedLpWg1",
            headerTooltip: "List Price WG1",
            editable: false,
            minWidth: 70,
            valueGetter: customListPriceWG1,
            cellEditor: CustomTextEditor,
            cellRenderer: showFixedValue,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "List price WG2",
            field: "revisedLpWg2",
            headerTooltip: "List price WG2",
            editable: false,
            minWidth: 70,
            valueGetter: customListPriceWG2,
            cellEditor: CustomTextEditor,
            cellRenderer: showFixedValue,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Total List Price",
            field: "totalRevisedLpWg1Wg2",
            headerTooltip: "Total List Price",
            editable: false,
            minWidth: 70,
            cellRenderer: totalListPrice,
            cellStyle: (params) => {
              return (
                params?.data?.orderStatus === "HOLD" && {
                  backgroundColor: theme.palette.warning.hold,
                }
              );
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showOrderCharacteristics,
          },

          { field: "range1Id", hide: true, editable: false },
          {
            headerName: "Range1",
            field: "range1",
            headerTooltip: "Range1",
            minWidth: 80,
            editable: false,
            cellEditor: SelectRange1,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Price Group1",
            field: "priceGroup1",
            headerTooltip: "Price Group",
            minWidth: 60,
            // cellStyle: { textAlign: "left" },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "color1Id", hide: true, editable: false },
          {
            headerName: "Front Color1",
            field: "color1",
            headerTooltip: "Front Color1",
            minWidth: 160,
            cellEditor: SelectFrontColor1,
            cellRenderer: renderFrontColor,
            editable: false,
            cellEditorParams: {
              onValidityChange: handleColorValidityChange,
            },
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "carcass1Id", hide: true, editable: false },
          {
            headerName: "Carcass1",
            field: "carcass1",
            headerTooltip: "Carcass1",
            minWidth: 160,
            editable: false,
            cellEditor: SelectCarcass,
            cellRenderer: renderCarcass,
            // cellStyle: { textAlign: "left" },
            cellEditorParams: { onValidityChange: handleColorValidityChange },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "handle1Id", hide: true, editable: false },
          {
            headerName: "Handle1",
            field: "handle1",
            headerTooltip: "Handle1",
            minWidth: 160,
            cellEditor: SelectHandle,
            editable: false,
            cellRenderer: renderHandle,
            cellEditorParams: { onValidityChange: handleColorValidityChange },
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7B241C",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "range2Id", hide: true, editable: false },
          {
            headerName: "Range2",
            field: "range2",
            headerTooltip: "Range2",
            minWidth: 80,
            editable: false,
            cellEditor: SelectRange2,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Price Group2",
            field: "priceGroup2",
            headerTooltip: "Price Group",
            minWidth: 60,
            // cellStyle: { textAlign: "left" },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "color2Id", hide: true, editable: false },
          {
            headerName: "Front Color2",
            field: "color2",
            headerTooltip: "Front Color2",
            minWidth: 160,
            editable: false,
            cellEditor: SelectFrontColor2,
            cellEditorParams: {
              onValidityChange: handleColorValidityChange,
            },
            cellRenderer: renderFrontColor,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "carcass2Id", hide: true, editable: false },
          {
            headerName: "Carcass2",
            field: "carcass2",
            headerTooltip: "Carcass2",
            minWidth: 160,
            editable: false,
            cellEditor: SelectCarcass,
            cellEditorParams: { onValidityChange: handleColorValidityChange },
            cellRenderer: renderCarcass,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "handle2Id", hide: true, editable: false },
          {
            headerName: "Handle2",
            field: "handle2",
            headerTooltip: "Handle2",
            minWidth: 160,
            editable: false,
            cellEditor: SelectHandle,
            cellEditorParams: { onValidityChange: handleColorValidityChange },
            cellRenderer: renderHandle,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#1B4F72",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "range3Id", hide: true, editable: false },
          {
            headerName: "Range3",
            field: "range3",
            headerTooltip: "Range3",
            minWidth: 80,
            editable: false,
            cellEditor: SelectRange3,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          {
            headerName: "Price Group3",
            field: "priceGroup3",
            headerTooltip: "Price Group",
            minWidth: 60,
            // cellStyle: { textAlign: "left" },
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                    color: "#fff",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "color3Id", hide: true, editable: false },
          {
            headerName: "Front Color3",
            field: "color3",
            headerTooltip: "Front Color3",
            minWidth: 160,
            editable: false,
            cellEditor: SelectFrontColor3,
            cellRenderer: renderFrontColor,
            cellEditorParams: {
              onValidityChange: handleColorValidityChange,
            },
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "carcass3Id", hide: true, editable: false },
          {
            headerName: "Carcass3",
            field: "carcass3",
            headerTooltip: "Carcass3",
            minWidth: 160,
            cellEditor: SelectCarcass,
            cellEditorParams: { onValidityChange: handleColorValidityChange },
            cellRenderer: renderCarcass,
            editable: false,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
          { field: "handle3Id", hide: true, editable: false },
          {
            headerName: "Handle3",
            field: "handle3",
            headerTooltip: "Handle3",
            minWidth: 160,
            editable: false,
            cellEditor: SelectHandle,
            cellEditorParams: { onValidityChange: handleColorValidityChange },
            cellRenderer: renderHandle,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#626567",
                    color: "#fff",
                  };
            },
            hide: !showOrderCharacteristics,
          },
        ],
      },
      {
        headerName: "LOGISTICS",
        children: [
          {
            headerName: "Volume",
            field: "volume",
            headerTooltip: "Volume",
            minWidth: 90,
            editable: true,
            // cellClass: "bg-logistics",
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            cellEditor: CustomTextEditor,
            cellEditorParams: { isNumeric: true },

            cellRenderer: showFixedValue,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showLogistics,
          },
          {
            headerName: "Weight",
            field: "weight",
            headerTooltip: "Weight",
            editable: true,
            minWidth: 90,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            cellEditor: CustomTextEditor,
            cellEditorParams: { isNumeric: true },

            cellRenderer: showFixedValue,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showLogistics,
          },
          {
            headerName: "No of Packs",
            field: "noOfPacks",
            headerTooltip: "No of Packs",
            minWidth: 60,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            editable: false,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showLogistics,
          },
          {
            headerName: "Internal Cont/ No",
            field: "internalContainerNo",
            headerTooltip: "Internal Cont/ No",
            minWidth: 60,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            editable: false,
            hide: !showLogistics,
          },
          {
            headerName: "Actual Cont/ No",
            field: "actualContainerNo",
            headerTooltip: "Actual Cont/ No",
            minWidth: 120,
            // cellStyle: {textAlign: 'left', backgroundColor: theme.palette.secondary.dark},
            // cellStyle: {  textAlign: "left"},
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7030a0",
                    color: "#fff",
                    textAlign: "left",
                  };
            },
            editable: false,
            hide: !showLogistics,
          },
          {
            headerName: "Port",
            field: "port",
            headerTooltip: "Port",
            minWidth: 60,
            // cellStyle: { textAlign: "left" },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    textAlign: "left",
                  }
                : {
                    backgroundColor: "#7030a0",
                    color: "#fff",
                    textAlign: "left",
                  };
            },
            // cellStyle: {textAlign: 'left', backgroundColor: theme.palette.secondary.dark},
            editable: false,
            hide: !showLogistics,
          },
          {
            headerName: "Mode of Shipping",
            field: "freightId",
            headerTooltip: "Mode of Shipping",
            editable: true,
            minWidth: 60,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            cellEditor: SelectShippingType,
            hide: !showLogistics,
          },
          {
            headerName: "Tour No",
            field: "tourNo",
            headerTooltip: "Tour No",
            minWidth: 60,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? { backgroundColor: theme.palette.warning.hold }
                : { backgroundColor: "#7030a0", color: "#fff" };
            },
            // cellStyle: { backgroundColor: theme.palette.secondary.dark},
            editable: false,
            hide: !showLogistics,
          },
        ],
      },
      {
        headerName: "COMMERCIAL",
        children: [
          {
            headerName: "Receivable",
            field: "grandTotal",
            headerTooltip: "Receivable",
            minWidth: 60,
            cellRenderer: showDiscountPercentMoney,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : {
                    backgroundColor: "#0070C0",
                    color: "#fff",
                  };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
          {
            headerName: "Payable",
            field: "netPayable",
            headerTooltip: "Payable",
            minWidth: 60,
            cellRenderer: showDiscountPercentMoney,
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#2f765f", color: "#fff" };
            },
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            hide: !showCommercialRcbl,
          },
        ],
      },

      {
        headerName: "HISTORY",
        children: [
          {
            headerName: "Order Received Date",
            field: "createdDate",
            headerTooltip: "Order Received Date",
            minWidth: 120,
            cellClass: "history",
            cellRenderer: handleDateFormat,
            editable: false,
            filter: "agDateColumnFilter",
            filterParams,

            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            hide: !showHistory,
          },
          {
            headerName: "Order Placed Date",
            field: "orderPlacedDate",
            headerTooltip: "Order Placed Date",
            minWidth: 120,
            editable: false,
            // cellClass: "history",
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            cellEditor: SelectDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "AB Received Date",
            field: "abReceivedDate",
            headerTooltip: "AB Received Date",
            editable: false,
            minWidth: 120,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            cellEditor: SelectDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Confirmed Date",
            field: "orderConfirmedDate",
            headerTooltip: "Confirmed Date",
            editable: false,
            minWidth: 120,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            cellEditor: SelectDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Loading Plan Date",
            field: "plannedLoadingDate",
            headerTooltip: "Loading Plan Date",
            minWidth: 120,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            filter: "agDateColumnFilter",
            editable: false,
            filterParams,
            cellEditor: PlannedLoadingDate,
            hide: !showHistory,
          },
          {
            headerName: "Loading Plan Week",
            field: "plannedLoadingWeek",
            headerTooltip: "Loading Plan Week",
            editable: false,
            minWidth: 80,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellEditor: PlannedLoadingWeek,
            hide: !showHistory,
          },
          {
            headerName: "Cut off Date",
            field: "cutoffDate",
            headerTooltip: "Cut off Date",
            editable: false,
            minWidth: 120,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            filter: "agDateColumnFilter",
            filterParams,
            cellEditor: SelectDate,
            hide: !showHistory,
          },
          {
            headerName: "Release date",
            field: "releaseDate",
            headerTooltip: "Release date",
            editable: false,
            minWidth: 80,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            editable: false,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Actual Loading Date",
            field: "actualLoadingDate",
            headerTooltip: "Actual Loading Date",
            editable: false,
            minWidth: 120,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellRenderer: handleDateFormat,
            cellEditor: ActualLoadingDate,
            hide: !showHistory,
            filter: "agDateColumnFilter",
            filterParams,
          },
          {
            headerName: "Actual Loading week",
            field: "actualLoadingWeek",
            headerTooltip: "Actual Loading week",
            editable: false,
            minWidth: 80,
            filterParams: {
              filters: [
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] },
                },
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    defaultToNothingSelected: true,
                    buttons: ["clear"],
                  },
                },
              ],
            },
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#744e4e", color: "#fff" };
            },
            cellEditor: ActualLoadingWeek,
            hide: !showHistory,
          },
        ],
      },
      {
        headerName: "APPROVALS",
        children: [
          {
            headerName: "SDR Status",
            field: "sdrStatus",
            headerTooltip: "SDR Status",
            editable: false,
            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#b276df", color: "#fff" };
            },
            minWidth: 90,
            hide: !showApprovals,
          },
          {
            headerName: "SDP Status",
            field: "sdpStatus",
            headerTooltip: "SDP Status",
            editable: false,

            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#b276df", color: "#fff" };
            },
            minWidth: 90,
            hide: !showApprovals,
          },
          {
            headerName: "Approval for booking",
            field: "bookingStatus",
            headerTooltip: "Approval for booking",

            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#b276df", color: "#fff" };
            },
            minWidth: 90,
            editable: false,
            hide: !showApprovals,
          },
          {
            headerName: "Approval to Release",
            field: "releaseStatus",
            headerTooltip: "Approval to Release",

            cellStyle: (params) => {
              return params?.data?.orderStatus === "HOLD"
                ? {
                    backgroundColor: theme.palette.warning.hold,
                    color: theme.palette.warning.contrastText,
                  }
                : { backgroundColor: "#b276df", color: "#fff" };
            },

            minWidth: 90,
            editable: false,
            hide: !showApprovals,
          },
        ],
      },
    ],
  });
  const selectColumns = useMemo(() => {
    const columns = getColumns(isMobile);
    return hasLogisticsRole
      ? columns.logisticsRoleCol
      : hasCustomerRole
      ? columns.hasCustomerRoleCol
      : columns.otherRoleCol;
  }, [
    hasCustomerRole,
    hasLogisticsRole,
    showOrderCharacteristics,
    showLogistics,
    showCommercialRcbl,
    showCommercialPbl,
    showHistory,
    showApprovals,
    theme,
    isMobile,
  ]);

  const getRowStyle = useCallback((params) => {
    if (params?.data && params?.data?.orderStatus === "HOLD") {
      return { background: "#ff8503" };
    }
    return null;
  }, []);

  function formattedNumbers(props) {
    let formattedNumbers;
    if (Number.isNaN(props?.value) || props?.value === 0) {
      formattedNumbers = 0;
    } else {
      formattedNumbers = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(props?.value);
    }

    {
      return (
        <span className="flex items-center">
          {" "}
          <p>{`${formattedNumbers}%`}</p>
        </span>
      );
    }
  }

  useEffect(() => {
    const getCustomerOptionsByTerritory = async () => {
      if (!filter?.territory?.length) {
        getCustomer();
        return;
      }

      try {
        const queryParams = filter.territory
          .map((id) => `territories=${encodeURIComponent(id)}`)
          .join("&");

        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/search/findByTerritoryIn?${queryParams}`;
        const list = await OAuthService.getList(url);

        let companies = list.data?._embedded?.companies;
        companies = companies.map((company) => {
          return {
            value: company.id,
            label: `${company?.id}-${company?.shortKey}-${company?.countryName}`,
            country: company?.countryName,
          };
        });
        companies = [{ value: "ALL", label: "ALL" }, ...companies];
        setCustomerOptions(companies);
      } catch (error) {
        toast.error(error.message || "Failed to fetch customer options");
      }
    };

    getCustomerOptionsByTerritory();
  }, [filter?.territory]);

  useEffect(() => {
    const partnerFilter = async () => {
      if (
        token?.scope?.includes("ROLE_IAM") &&
        !(
          token?.scope?.includes("ROLE_ADMIN") ||
          token?.scope?.includes("ROLE_SOPDIR")
        )
      ) {
        if (gridRef.current?.api) {
          gridRef.current.api.showLoadingOverlay();
        }
        try {
          const findAllByAreaManagerUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territoryList}/search/findAllByAreaManagerContains?email=${token.email}`;
          const areaManager = await OAuthService.getList(
            findAllByAreaManagerUrl,
          );
          const areaManagerIds =
            areaManager?.data?._embedded?.territories?.map((t) => t.id) || [];
          setFilter({ ...filter, territory: [areaManagerIds[0]] });

          let updatedFilter = { ...filter, territory: [areaManagerIds[0]] };
          loadDataForIAM(updatedFilter);
        } catch (error) {
          toast.error(error.message);
          gridRef.current?.api?.showNoRowsOverlay();
        }
      }
    };
    partnerFilter();
  }, []);
  const loadDataForIAM = async (filterData) => {
    if (!gridRef.current?.api) return;

    gridRef.current.api.showLoadingOverlay();
    try {
      let orders = [];

      if (token && hasIAMRole) {
        if (filterStatus) {
          const res = await OAuthService.getPostList(
            searchUrl,
            savedFilterData,
          );
          orders = res?.data?.content;
          getOrderTotalCalculation();
          setFilter(savedFilterData);
        } else {
          const res = await OAuthService.getPostList(searchUrl, filterData);
          orders = res?.data?.content;
          getOrderTotalCalculation(filterData);
        }
      }

      const newArray = orders?.map((obj) => {
        Object.keys(obj).forEach((key) => {
          if (key !== "slabNum" && key !== "vendorSlabNo") {
            if (
              obj[key] === undefined ||
              obj[key] === null ||
              obj[key] === "" ||
              obj[key] === 0
            ) {
              obj[key] = "";
            }
          }
        });
        return obj;
      });

      setRowData(newArray);
      if (newArray.length === 0) {
        gridRef.current.api.showNoRowsOverlay();
      } else {
        gridRef.current.api.hideOverlay();
      }
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
      setRowData([]);
      gridRef.current?.api?.hideOverlay();
    }
  };

  const loadData = useCallback(async () => {
    let list = "";
    let orders = [];

    try {
      if (!gridRef.current?.api) return;

      gridRef.current.api.showLoadingOverlay();

      if (token) {
        if (filterStatus) {
          const res = await OAuthService.getPostList(
            searchUrl,
            savedFilterData,
          );
          orders = res?.data?.content;
          getOrderTotalCalculation();
        } else {
          if (hasSopAdminRole || hasLogisticsRole) {
            list = await OAuthService.getList(
              `${url}/search/findByDeletedFalse?sort=createdDate,desc&size=1000`,
            );
            orders = list.data?._embedded?.orders;
          } else if (hasPartnerOrderProRole) {
            list = await OAuthService.getList(
              `${getMyOrdersUrl}?page=0&size=1000&sort=createdDate`,
            );
            orders = list.data?.content;
          } else if (hasPartnerAdminRole) {
            list = await OAuthService.getList(
              `${url}/search/findByCustomerNumAndDeletedFalseOrderByCreatedDateDesc?customerNum=${token?.company}&sort=createdDate,desc&size=1000`,
            );
            orders = list.data?._embedded?.orders;
          } else if (hasShwrmMngrRole) {
            const showroomIds = toShowroomIdList(token?.showroom);
            const showroomLists = await Promise.all(
              showroomIds.map((showroomId) =>
                OAuthService.getList(
                  `${url}/search/findByCustomerNumAndShowroomNumAndDeletedFalseOrderByCreatedDateDesc?showroomNum=${showroomId}&sort=createdDate,desc&size=1000&customerNum=${token?.company}`,
                ),
              ),
            );
            orders = showroomLists.flatMap(
              (showroomList) => showroomList.data?._embedded?.orders || [],
            );
            if (showroomIds.length > 1) {
              orders.sort(
                (a, b) => new Date(b.createdDate) - new Date(a.createdDate),
              );
            }
          } else if (hasOrderProcesorRole) {
            list = await OAuthService.getList(
              `${url}/search/findByAssignee?assignedToMail=${token?.email}&sort=createdDate,desc&size=1000`,
            );
            orders = list.data?._embedded?.orders;
          } else if (hasIAMRole) {
            const res = await OAuthService.getPostList(searchUrl, filter);
            orders = res?.data?.content;
            getOrderTotalCalculation(filter);
          }
        }
      }

      const newArray = orders?.map((obj) => {
        Object.keys(obj).forEach((key) => {
          if (key !== "slabNum" && key !== "vendorSlabNo") {
            if (
              obj[key] === undefined ||
              obj[key] === null ||
              obj[key] === "" ||
              obj[key] === 0
            ) {
              obj[key] = "";
            }
          }
        });
        return obj;
      });

      setRowData(newArray);
      gridRef.current?.api?.hideOverlay();
    } catch (error) {
      console.error(error);
      gridRef.current?.api?.hideOverlay();
      toast.error(error?.response?.data?.errorMessage || error.message);
      setRowData([]);
    }
  }, [
    filterStatus,
    token,
    hasPartnerOrderProRole,
    hasPartnerAdminRole,
    hasShwrmMngrRole,
  ]);

  const getCustomer = async () => {
    const list = await OAuthService.getList(
      companiesUrl +
        `/search/findByCustomerTypes?customerTypes=REGULAR&sort=id,ase,&size=1000`,
    );
    let companies = list.data?._embedded?.companies;
    companies = companies.map((company) => {
      return {
        value: company.id,
        label: `${company?.id}-${company?.shortKey}-${company?.countryName}`,
        country: company?.countryName,
      };
    });
    companies = [{ value: "ALL", label: "ALL" }, ...companies];
    setCustomerOptions(companies);
  };
  useEffect(() => {
    if (filterStatus) {
      setFilter(savedFilterData);
    }
  }, []);

  const getShowroom = async () => {
    try {
      if (Number(filter.custNum)) {
        const showroomByCompanyUrl = `${companiesUrl}/${filter.custNum}/showrooms`;
        const list = await OAuthService.getList(showroomByCompanyUrl);
        let showrooms = list.data?._embedded?.showrooms;
        showrooms = showrooms.map((showroom) => {
          return {
            value: showroom.id,
            label: showroom.name,
          };
        });
        // showrooms = [{ value: 'ALL', label: 'ALL' },...showrooms]
        setShowroomOptions(showrooms);
      }
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };

  const getVendorsList = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
    try {
      const list = await OAuthService.getList(
        `${url}/search/findByActive?active=true`,
      );
      let factoryVendorData = list.data?._embedded?.factoryVendors;
      factoryVendorData = factoryVendorData.map((vendor) => {
        return {
          label: vendor.shortKey,
          value: vendor.shortKey,
          id: vendor.id,
        };
      });
      setFactoryVendors(factoryVendorData);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };

  const getCompanyInfo = async () => {
    try {
      if (token && hasCustomerRole) {
        const list = await OAuthService.getList(
          findPartnerById + "/" + token?.company,
        );
        let companyDetails = list.data;
        const companyDetail = {
          value: companyDetails.id,
          label: `${companyDetails?.id}-${companyDetails?.countryCode}-${companyDetails?.countryName}`,
        };
        // filter.custNum = companyDetails.companyId;
        setCustomerName(companyDetail);
        if (filterStatus) {
          setFilter(savedFilterData);
        } else {
          setFilter({ ...filter, custNum: companyDetail.value });
        }
        getOrderTotalCalculation();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error.message ||
          "Customer name is not found",
      );
    }
  };

  const getShowroomInfo = async () => {
    try {
      const showroomIds = toShowroomIdList(token?.showroom);
      if (token && showroomIds.length > 0) {
        const lists = await Promise.all(
          showroomIds.map((showroomId) =>
            OAuthService.getList(
              orderStatusUrl + `api/showrooms/${showroomId}`,
            ),
          ),
        );
        let companyShowroom = lists.map((list) => ({
          value: list.data?.id,
          label: list.data?.name,
        }));
        //if (hasPartnerOrderProRole) {
        //filter.showroomNum = [list.data?.id];
        //}
        setCompanyShowroom(companyShowroom);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error.message ||
          "Showroom is not available",
      );
    }
  };

  const getOrderTotalCalculation = async (filterData) => {
    let updatedValues = filterData || {};
    for (const key in filter) {
      if (Object.hasOwnProperty.call(filter, key)) {
        updatedValues[key] = filter[key] === "ALL" ? "" : filter[key];
      }
    }
    if (filterStatus) {
      updatedValues = savedFilterData;
    }
    try {
      const list = await OAuthService.getPostList(
        orderCalculationURL,
        savedFilterData,
      );
      setOrderCalculation(list?.data);
    } catch (error) {
      toast.error("Total value not available");
    }
  };

  const totalValueFormatted = (value, key) => {
    let formattedNumbers;
    if (key === "volume" || key === "weight") {
      formattedNumbers = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 3,
        minimumFractionDigits: 3,
      }).format(value);
    } else {
      formattedNumbers = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(value);
    }
    return formattedNumbers;
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);

  useEffect(() => {
    getCustomer();
    getVendorsList();
    getCompanyInfo();
    getShowroomInfo();
    if (!filterStatus) {
      getOrderTotalCalculation();
    }
  }, []);

  useEffect(() => {
    if (filter.custNum || savedFilterData?.custNum) {
      getShowroom();
    }
  }, [filter, savedFilterData]);

  const createDataSource = () => {
    return {
      getRows: async (params) => {
        let page = params.request.endRow / 20;
        try {
          const urlService = url + `?sort=customerName,desc&page=${page - 1}`;
          const list = await OAuthService.getList(urlService);
          const totalPages = list.data.page.totalPages;
          const totalElements = list.data.page.totalElements;
          // const orders = list.data?._embedded?.orders;
          if (list.data?._embedded?.orders.length > 0) {
            let lastRow = () => {
              if (totalPages <= 1) return totalElements;
              else if (page <= totalPages / 2) return -1;
              else return totalElements;
            };
            params.successCallback(list.data?._embedded?.orders, lastRow());
          } else {
            params.successCallback(
              [{ columnNameField: "No results found" }],
              1,
            );
          }
        } catch (error) {
          params.failCallback();
          // Handle error appropriately
          console.error(error.message);
        }
      },
    };
  };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    params.api.addEventListener("cellEditingStarted", () => {
      setIsEditing(true);
    });
  }, []);
  const defaultColDef = useMemo(
    () => ({
      resizable: true,
      editable: (params) => params.node.isSelected(),
    }),
    [],
  );

  const onFilterTextBoxChanged = useCallback(() => {
    const filterText = document.getElementById("filter-text-box").value;
    gridRef.current.api.setQuickFilter(filterText);
  }, []);
  // To  fix the issue with Sr no column will always on left
  const onFirstDataRendered = useCallback(() => {
    if (!gridApi) return;

    const newColumnDefs = selectColumns.map((group) => {
      if (group.children) {
        group.children = group.children.map((column) => {
          if (column.field === "skipPromotion") {
            return { ...column, hide: !hasSopAdminRole };
          }
          return column;
        });
      }
      return group;
    });

    gridApi.setColumnDefs(newColumnDefs);

    setTimeout(() => {
      columnApi.setColumnPinned("srNo", "left");
      columnApi.moveColumn("srNo", 0);
    }, 0);
  }, [gridApi, selectColumns, hasSOPRole]);

  const onSelectionChanged = (params) => {
    setSelectedRows(params?.api?.getSelectedRows());
  };
  const onSortRefresh = (params) => {
    params.api.refreshCells();
  };
  const goToRoleEdit = useCallback(
    (data) => {
      if (data?.id !== undefined) {
        navigate("/order/order-details/" + data.id);
      }
    },
    [navigate],
  );
  const onRowDoubleClicked = (params) => {
    if (isMobile || isEditing) return;
    params.api.stopEditing();
    goToRoleEdit(params?.data);
  };

  const onRowClicked = (params) => {
    if (!isMobile || isEditing) return;
    goToRoleEdit(params?.data);
  };
  // const onRowDoubleClicked = (params) => {
  //   params.api.stopEditing();

  //   const id = params?.data?.id;
  //   if (id) {
  //     navigate("/order/order-details/" + id);
  //   }
  // };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseCancelOrder = () => {
    setOpenCancel(false);
    // setSelectedRows([]);
  };
  const handleOpenCancelPopup = () => {
    setOpenCancel(true);
  };
  const handleAdvanceSearch = () => {
    setShowSearch(!showSearch);
  };
  const handleListView = () => {
    setListView(true);
    setGridView(false);
  };
  const handleGridView = () => {
    setGridView(true);
    setListView(false);
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "Orders.xlsx",
      sheetName: "Orders",
      processCellCallback: (excelParams) => {
        const field = excelParams.column.getColId();
        const value = excelParams.value;

        const dateFields = [
          "createdDate",
          "orderPlacedDate",
          "abReceivedDate",
          "orderConfirmedDate",
          "plannedLoadingDate",
          "cutoffDate",
          "releaseDate",
          "actualLoadingDate",
        ];

        if (dateFields.includes(field) && value) {
          return moment(value).format("DD-MM-YYYY");
        }

        return value;
      },
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);
  const handleDefaultGridState = () => {
    if (!gridRef.current) return;

    gridRef.current.api.setFilterModel(null);

    gridRef.current.columnApi.resetColumnState();
  };

  const handleWaitingOrderStatus = async (type) => {
    gridRef.current.api.showLoadingOverlay();
    const selectedRowId = selectedRows.map((row) => row.id);
    try {
      const model = {
        orderIds: selectedRowId,
        discountType: type,
      };
      const orderIdsParam = selectedRowId.join(",");
      const url = `${orderToMoveSpecialDiscount}`;
      await OAuthService.addData(url, model);

      const updatedRows = [];
      const updatedRowNodes = [];

      selectedRows.forEach((selectRow) => {
        const rowIndex = rowData?.findIndex((row) => row.id === selectRow.id);
        if (rowIndex !== -1) {
          const updatedRow = {
            ...rowData[rowIndex],
            ...(type === "SDR"
              ? { sdrStatus: "WAITING" }
              : { sdpStatus: "WAITING" }),
          };
          rowData[rowIndex] = updatedRow;
          updatedRows.push(updatedRow);
        }
      });

      if (updatedRows.length > 0) {
        gridRef.current.api.applyTransaction({ update: updatedRows });

        updatedRows.forEach((row) => {
          const node = gridRef.current.api.getRowNode(row.id);
          if (node) updatedRowNodes.push(node);
        });

        gridRef.current.api.refreshCells({
          rowNodes: updatedRowNodes,
          columns: ["commissionName"],
          force: true,
        });
      }

      setRowData([...rowData]);

      gridRef.current.api.hideOverlay();
      toast.success(`${type} status change Successfully`);
    } catch (error) {
      gridRef.current.api.hideOverlay();
      toast.error(error?.response?.data?.errorMessage || error.message);
      console.error(error);
    }
  };

  const orderHeaderAction = () => {
    return (
      <>
        <div className="flex flex-row flex-wrap md:flex-nowrap items-center gap-4 w-full justify-start md:justify-end">
          <Tooltip title={"Download AB's"}>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              sx={{ minWidth: "32px", p: "4px 6px" }}
              onClick={handleDownloadAb}
              disabled={
                selectedRows.length === 0 ||
                selectedRows.some((obj) =>
                  [
                    "NEW",
                    "ASSIGNED",
                    "IN_PROGRESS",
                    "HOLD",
                    "ORDER_PLACED",
                    "ACK_FRM_FACTORY",
                    "CANCELLED",
                  ].includes(obj.orderStatus),
                ) ||
                (hasCustomerRole &&
                  selectedRows.some(
                    (obj) =>
                      obj.orderStatus === "AB_RECEIVED" && !obj.abShareDate,
                  ))
              }
            >
              <FuseSvgIcon size={16}>heroicons-solid:download</FuseSvgIcon>
            </Button>
          </Tooltip>
          {(hasAdminRole || hasLogisticsRole) && (
            <>
              <Tooltip title={"Edit OMS"}>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  sx={{ minWidth: "32px", p: "4px 6px" }}
                  onClick={handleEditRow}
                  disabled={hasOrderEditable || hasIAMRole || hasShwrmMngrRole}
                >
                  <FuseSvgIcon size={16}>heroicons-solid:pencil</FuseSvgIcon>
                </Button>
              </Tooltip>

              {selectedRows.length > 0 && (
                <Tooltip title={isSaving ? "Saving..." : "Save OMS"}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    sx={{ minWidth: "32px", p: "4px 6px" }}
                    onClick={handleSubmit}
                    disabled={
                      (updateRowData.length === 0 && !isEditing) ||
                      isSaving ||
                      selectedRows.some((row) => invalidUniqueIdRows[row.id]) ||
                      selectedRows.some((row) => invalidColorRows[row.id]) ||
                      selectedRows.some((row) => invalidMaterialRows[row.id])
                    }
                  >
                    {isSaving ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : (
                      <FuseSvgIcon size={16}>material-solid:save</FuseSvgIcon>
                    )}
                  </Button>
                </Tooltip>
              )}
            </>
          )}

          {!hasCustomerRole && !hasLogisticsRole && (
            <>
              <Tooltip title={"Update to SDR status"}>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  sx={{ height: "26px", fontSize: "11px", px: 2 }}
                  onClick={() => handleWaitingOrderStatus("SDR")}
                >
                  SDR
                </Button>
              </Tooltip>
              {!hasIAMRole && !hasLogisticsRole && (
                <Tooltip title={"Update to SDP status"}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    sx={{ height: "26px", fontSize: "11px", px: 2 }}
                    onClick={() => handleWaitingOrderStatus("SDP")}
                  >
                    SDP
                  </Button>
                </Tooltip>
              )}
            </>
          )}

          {!(hasCustomerRole || hasIAMRole || hasLogisticsRole) && (
            <Tooltip title={"Cancel Order"}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                sx={{ minWidth: "32px", p: "4px 6px" }}
                onClick={handleOpenCancelPopup}
                disabled={
                  selectedRows.length === 0 ||
                  selectedRows.some((obj) =>
                    ["CANCELLED"].includes(obj.orderStatus),
                  )
                }
              >
                <FuseSvgIcon size={16}>material-solid:cancel</FuseSvgIcon>
              </Button>
            </Tooltip>
          )}

          <Tooltip title={"Clear Filters"}>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              sx={{ minWidth: "32px", p: "4px 6px" }}
              onClick={handleClear}
            >
              <FuseSvgIcon size={16}>material-solid:clear_all</FuseSvgIcon>
            </Button>
          </Tooltip>

          <Tooltip title={"Search"}>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              sx={{ minWidth: "32px", p: "4px 6px" }}
              onClick={searchHandler}
            >
              <FuseSvgIcon size={16}>material-solid:search</FuseSvgIcon>
            </Button>
          </Tooltip>

          {!hasCustomerRole && (
            <Tooltip title={"Show/Hide Groups"}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                sx={{ minWidth: "32px", p: "4px 6px" }}
                onClick={handleClick}
              >
                <FuseSvgIcon size={16}>
                  material-solid:remove_red_eye
                </FuseSvgIcon>
              </Button>
            </Tooltip>
          )}

          <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
              "aria-labelledby": "demo-customized-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    name="showOrderCharacteristics"
                    checked={showOrderCharacteristics}
                    onChange={() =>
                      setShowOrderCharacteristics(!showOrderCharacteristics)
                    }
                  />
                }
                label="ORDER CHARACTERISTICS"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="showLogistics"
                    checked={showLogistics}
                    onChange={() => setShowLogistics(!showLogistics)}
                  />
                }
                label="LOGISTICS"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="showCommercialRcbl"
                    checked={showCommercialRcbl}
                    onChange={() => setShowCommercialRcbl(!showCommercialRcbl)}
                  />
                }
                label="COMMERCIAL (RCBL)"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="showCommercialPbl"
                    checked={showCommercialPbl}
                    onChange={() => setShowCommercialPbl(!showCommercialPbl)}
                  />
                }
                label="COMMERCIAL (PBL)"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="showHistory"
                    checked={showHistory}
                    onChange={() => setShowHistory(!showHistory)}
                  />
                }
                label="HISTORY"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="showApprovals"
                    checked={showApprovals}
                    onChange={() => setShowApprovals(!showApprovals)}
                  />
                }
                label="APPROVALS"
              />
            </FormGroup>
          </StyledMenu>

          {!(hasCustomerRole || hasIAMRole || hasLogisticsRole) && (
            <Tooltip title={"Order Recalculate"}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                sx={{ minWidth: "32px", p: "4px 6px", ml: 1 }}
                onClick={handleOrderRecalculate}
                disabled={selectedRows.length === 0}
              >
                <FuseSvgIcon size={16}>material-solid:calculate</FuseSvgIcon>
              </Button>
            </Tooltip>
          )}

          {autoSizeMode ? (
            <Tooltip title={"Auto-Size Columns"}>
              <Button
                variant="contained"
                color="error"
                size="small"
                sx={{ minWidth: "32px", p: "4px 6px" }}
                onClick={() => {
                  autoSizeAll(false);
                  setAutoSizeMode(false);
                }}
              >
                <FuseSvgIcon size={16}>material-solid:zoom_out_map</FuseSvgIcon>
              </Button>
            </Tooltip>
          ) : (
            <Tooltip title={"Reset Columns"}>
              <Button
                variant="contained"
                color="error"
                size="small"
                sx={{ minWidth: "32px", p: "4px 6px" }}
                onClick={() => {
                  autoSizeAll(true);
                  setAutoSizeMode(true);
                }}
              >
                <FuseSvgIcon size={16}>material-solid:zoom_out_map</FuseSvgIcon>
              </Button>
            </Tooltip>
          )}

          <Button
            variant="contained"
            color="secondary"
            size="small"
            sx={{ height: "26px", fontSize: "11px", px: 2 }}
            onClick={(e) => setExtraActionsAnchor(e.currentTarget)}
            endIcon={<KeyboardArrowDownIcon />}
          >
            Tools
          </Button>

          <Menu
            anchorEl={extraActionsAnchor}
            open={openExtraActions}
            onClose={() => setExtraActionsAnchor(null)}
            elevation={3}
          >
            {!(hasCustomerRole || hasIAMRole || hasLogisticsRole) &&
              filter.showDeleted && (
                <MenuItem
                  onClick={() => {
                    handleRestoreOrders();
                    setExtraActionsAnchor(null);
                  }}
                  disabled={
                    selectedRows.length === 0 ||
                    selectedRows.some((row) => !row.deleted)
                  }
                >
                  <FuseSvgIcon size={16} className="mr-8">
                    material-twotone:restore_from_trash
                  </FuseSvgIcon>
                  Restore Orders
                </MenuItem>
              )}

            {!(hasCustomerRole || hasIAMRole || hasLogisticsRole) && (
              <MenuItem
                onClick={() => {
                  handleUpdateTerritory();
                  setExtraActionsAnchor(null);
                }}
                disabled={selectedRows.length === 0}
              >
                <TitleIcon size={16} className="mr-8" />
                Update Territory
              </MenuItem>
            )}
            {!(hasCustomerRole || hasIAMRole || hasLogisticsRole) && (
              <MenuItem
                onClick={() => {
                  handleGenerateAoReport();
                  setExtraActionsAnchor(null);
                }}
                disabled={!filter?.partOrderReason?.length}
              >
                <TitleIcon size={16} className="mr-8" />
                Export AO Reason Report
              </MenuItem>
            )}

            <MenuItem
              onClick={() => {
                onBtExport();
                setExtraActionsAnchor(null);
              }}
            >
              <FuseSvgIcon size={16} className="mr-8">
                heroicons-solid:save
              </FuseSvgIcon>
              Export Order List
            </MenuItem>

            <MenuItem
              onClick={() => {
                handleDefaultGridState();
                setExtraActionsAnchor(null);
              }}
            >
              <FuseSvgIcon size={16} className="mr-8">
                material-outline:grid_on
              </FuseSvgIcon>
              Default Grid State
            </MenuItem>
          </Menu>
        </div>
      </>
    );
  };

  const autoSizeAll = useCallback((skipHeader) => {
    setTimeout(() => {
      const allColumnIds = [];
      gridRef?.current?.columnApi?.getColumns()?.forEach((column) => {
        allColumnIds.push(column?.getId());
      });
      if (skipHeader) {
        gridRef.current.api.sizeColumnsToFit({
          defaultMinWidth: 65,
          columnLimits: [{ key: "customerName", minWidth: 65 }],
          columnLimits: [{ key: "orderStatus", minWidth: 75 }],
          columnLimits: [{ key: "abNumber", minWidth: 75 }],
        });
      } else {
        gridRef?.current?.columnApi?.autoSizeColumns(allColumnIds, skipHeader);
      }
    }, 500);
  }, []);

  useEffect(() => {
    if (selectedStatus) {
      handleFilter();
    }
  }, [selectedStatus]);

  useEffect(() => {
    loadData();
  }, [filterStatus, savedFilterData]);

  const handleOrderRecalculate = async () => {
    const orderIds = selectedRows.map((row) => row.id);
    try {
      const response = await OAuthService.addData(
        `${resourceUrl}/api/recalculateOrders`,
        orderIds,
      );

      const updatedRows = response.data;

      gridRef.current.api.applyTransaction({
        update: updatedRows,
      });

      gridRef.current.api.refreshCells();

      toast.success("Orders recalculated successfully");
    } catch (error) {
      toast.error(error.response?.data?.errorMessage || error?.message);
    }
  };
  const handleUpdateTerritory = async () => {
    const orderIds = selectedRows.map((row) => row.id);

    const formData = new FormData();
    orderIds.forEach((id) => {
      formData.append("orderIds", id);
    });

    try {
      const response = await OAuthService.addData(
        `${resourceUrl}/api/updateTerritory`,
        orderIds,
      );

      const updatedRows = response.data;

      gridRef.current.api.applyTransaction({
        update: updatedRows,
      });

      gridRef.current.api.refreshCells();
      toast.success("Territories updated successfully");
    } catch (error) {
      toast.error(error.response?.data?.errorMessage || error?.message);
    }
  };
  const formatDateReport = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d)) return "";
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    return `${dd}/${mm}/${d.getFullYear()}`;
  };

  const IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "gif"];

  const getExtension = (name = "") => name.split(".").pop().toLowerCase();
  const isImageFile = (name) => IMAGE_EXTENSIONS.includes(getExtension(name));

  const getPictureUrl = (picture) => {
    const base = `${process.env.REACT_APP_RESOURCE_API_KEY_URL || ""}`;
    const baseUrl = base.endsWith("/") ? base : base + "/";
    return `${baseUrl}api/static/downloadPicture?picture=${encodeURIComponent(
      picture,
    )}`;
  };

  const fetchPicture = async (pictureName) => {
    try {
      const res = await OAuthService.getDownload(getPictureUrl(pictureName));
      const data = res?.data;
      if (!data) return null;

      const blob = data instanceof Blob ? data : new Blob([data]);
      const buffer = await blob.arrayBuffer();

      let extension = getExtension(pictureName);
      if (extension === "jpg") extension = "jpeg";

      return { buffer, extension };
    } catch (e) {
      console.log("Picture download failed:", pictureName, e);
      return null;
    }
  };
  const handleGenerateAoReport = async () => {
    if (isExportingAo) return;

    setIsExportingAo(true);
    try {
      const res = await OAuthService.getPostList(searchAoUrl, {
        ...filter,
        orderType: "AO",
      });

      const orders = Array.isArray(res?.data)
        ? res.data
        : res?.data?.content || [];

      if (!orders.length) {
        toast.error("No data found for AO report");
        return;
      }

      const headers = [
        "AO Received Date",
        "Loading Date of Original order",
        "AB number",
        "Commission Name",
        "Branch",
        "Customer",
        "Vend",
        "Pos. No.",
        "Article Code",
        "AO Reason",
        "AO Reason Sub-category",
        "Remarks",
        "Picture",
      ];
      const PICTURE_COL = headers.length;

      const imageNames = [
        ...new Set(
          orders
            .flatMap((o) => o.partOrderDetails || [])
            .map((d) => d.picture)
            .filter((p) => p && isImageFile(p)),
        ),
      ];
      const pictureCache = {};
      await Promise.all(
        imageNames.map(async (name) => {
          pictureCache[name] = await fetchPicture(name);
        }),
      );

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("AO Reason Report", {
        views: [{ state: "frozen", ySplit: 1 }],
      });

      worksheet.columns = [
        { width: 16 },
        { width: 22 },
        { width: 14 },
        { width: 45 },
        { width: 10 },
        { width: 12 },
        { width: 12 },
        { width: 14 },
        { width: 16 },
        { width: 35 },
        { width: 30 },
        { width: 45 },
        { width: 28 },
      ];

      const thinBorder = {
        top: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };

      const headerRow = worksheet.addRow(headers);
      headerRow.height = 45;
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, size: 11 };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD9D9D9" },
        };
        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
          wrapText: true,
        };
        cell.border = thinBorder;
      });

      const IMG_W = 150;
      const IMG_H = 90;
      const ROW_HEIGHT_WITH_IMG = 80;
      const imageIdCache = {};

      const setLink = (cell, picture) => {
        cell.value = {
          text: picture,
          hyperlink: getPictureUrl(picture),
          tooltip: "Click to download",
        };
        cell.font = { color: { argb: "FF0563C1" }, underline: true };
      };

      orders.forEach((order) => {
        const details = order.partOrderDetails?.length
          ? order.partOrderDetails
          : [{}];

        details.forEach((detail, index) => {
          const isFirst = index === 0;

          const row = worksheet.addRow([
            isFirst ? formatDateReport(order.createdDate) : "",
            isFirst ? formatDateReport(order.parentLoadingDate) : "",
            isFirst ? order.abNumber || "" : "",
            isFirst ? order.commissionName || "" : "",
            isFirst ? order.orderCategory || "" : "",
            isFirst ? order.customerNum ?? "" : "",
            isFirst ? order.vendorNum ?? "" : "",
            detail.posNo || "",
            detail.articleCode || "",
            detail.reason || "",
            detail.subReason || "",
            detail.remark || "",
            "",
          ]);

          row.eachCell({ includeEmpty: true }, (cell) => {
            cell.alignment = { vertical: "middle", wrapText: true };
            cell.border = thinBorder;
          });

          if (!detail.picture) return;

          const pic = isImageFile(detail.picture)
            ? pictureCache[detail.picture]
            : null;

          if (pic) {
            if (imageIdCache[detail.picture] === undefined) {
              imageIdCache[detail.picture] = workbook.addImage({
                buffer: pic.buffer,
                extension: pic.extension,
              });
            }

            row.height = ROW_HEIGHT_WITH_IMG;

            worksheet.addImage(imageIdCache[detail.picture], {
              tl: { col: PICTURE_COL - 1 + 0.1, row: row.number - 1 + 0.1 },
              ext: { width: IMG_W, height: IMG_H },
              editAs: "oneCell",
            });
          } else {
            setLink(row.getCell(PICTURE_COL), detail.picture);
          }
        });
      });

      const today = formatDate(new Date()).replaceAll("/", "-");
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      const objectUrl = window.URL.createObjectURL(blob);
      link.href = objectUrl;
      link.download = `AO_Reason_Report_${today}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.log(error.message);
      toast.error(error.message);
    } finally {
      setIsExportingAo(false);
    }
  };
  const handleClear = async () => {
    if (hasCustomerRole) {
      if (hasPartnerOrderProRole) {
        setFilter({
          ...initialValues,
          custNum: customerName?.value,
          orderStatus2: null,
        });
      } else {
        setFilter({
          ...initialValues,
          custNum: customerName?.value,
          orderStatus2: null,
        });
      }
    } else if (hasIAMRole) {
      setFilter({ ...initialValues, orderStatus2: null });
      const updateFilter = { ...initialValues, orderStatus2: null };
      // loadDataForIAM(updateFilter);
    } else {
      setFilter({ ...initialValues, orderStatus2: null });
    }

    dispatch(clearFilter());

    gridRef.current.api.setQuickFilter("");
    document.getElementById("filter-text-box").value = "";
    setVendorId("");
    setRangeId("");
    setDateType("");
    setYear(null);
    setMonth(null);
    setWeek(null);
    setSelectedStatus("");
    setFromDate(null);
    setToDate(null);
    try {
      const list = await OAuthService.getPostList(orderCalculationURL, {});
      setOrderCalculation(list?.data);
      // getOrderTotalCalculation();
      // setSelectedRows([]);
    } catch (error) {
      toast.error("Total value not available");
    }
  };

  const handleTextChange = (event, key) => {
    setFilter({
      ...filter,
      [event.target.name]: event.target.value.toUpperCase(),
    });
  };

  const handleSelectChange = (data, action, key) => {
    const value = action.action === "clear" ? "" : data?.value;

    if (key === "year") {
      setYear(value);
      return;
    }

    if (key === "month") {
      setMonth(value);
      return;
    }

    if (key === "week") {
      setWeek(value);
      return;
    }

    if (key === "vendorShortKey") {
      setFilter((prev) => ({
        ...prev,
        vendorShortKey: value ? [value] : [],
        mainRange: null,
        mainPriceGrp: null,
        mainColour: null,
      }));

      setVendorId(value ? data.id : "");
      return;
    }
    setFilter((prev) => {
      if (key === "custNum") {
        setCustCountry(value ? data.country : "");

        if (value === "ALL" || action.action === "clear") {
          setShowroomOptions([]);
        }

        return {
          ...prev,
          custNum: value,
          showroomNum: [],
        };
      }

      return {
        ...prev,
        [key]: value,
      };
    });
  };

  const handleMultiChange = (data, name) => {
    if (data) {
      const multyChange = data.map((row) => row.value);
      setFilter({ ...filter, [name]: multyChange });
    }
  };
  const extractDateInfoFromFilter = (filter) => {
    const dateMap = [
      {
        type: "createdDt",
        from: filter.createdDtFrom,
        to: filter.createdDtTo,
      },
      {
        type: "plannedLoadingDate",
        from: filter.plannedLoadingDateFrom,
        to: filter.plannedLoadingDateTo,
        year: filter.plannedLoadingYear,
        week: filter.plannedLoadingWeek,
      },
      {
        type: "actualLoadingDate",
        from: filter.actualLoadingDateFrom,
        to: filter.actualLoadingDateTo,
        year: filter.actualLoadingYear,
        week: filter.actualLoadingWeek,
      },
      {
        type: "orderPlacedDate",
        from: filter.orderPlacedDateFrom,
        to: filter.orderPlacedDateTo,
      },
      {
        type: "orderConfirmedDate",
        from: filter.orderConfirmedDateFrom,
        to: filter.orderConfirmedDateTo,
        year: filter.orderConfirmedYear,
        week: filter.orderConfirmedWeek,
      },
      {
        type: "abReceivedDate",
        from: filter.abReceivedDateFrom,
        to: filter.abReceivedDateTo,
        year: filter.abReceivedYear,
        week: filter.abReceivedWeek,
      },
    ];

    return dateMap.find((d) => d.from || d.to || (d.year && d.week));
  };
  useEffect(() => {
    if (!filterStatus || !savedFilterData) return;

    setFilter(savedFilterData);

    const dateInfo = extractDateInfoFromFilter(savedFilterData);

    if (!dateInfo) return;

    setDateType(dateInfo.type);

    if (dateInfo.year && dateInfo.week) {
      setYear(dateInfo.year);
      setWeek(dateInfo.week);
      setMonth(null);
      setFromDate(null);
      setToDate(null);
      return;
    }

    if (dateInfo.from && dateInfo.to) {
      setFromDate(dateInfo.from);
      setToDate(dateInfo.to);
      setYear(null);
      setMonth(null);
      setWeek(null);
    }
  }, [savedFilterData, filterStatus]);

  const handleDateTypeChange = (data, action) => {
    const value = action.action === "clear" ? "" : data.value;

    setDateType(value);

    setFilter((prev) => ({
      ...prev,
      createdDtFrom: null,
      createdDtTo: null,
      plannedLoadingDateFrom: null,
      plannedLoadingDateTo: null,
      actualLoadingDateFrom: null,
      actualLoadingDateTo: null,
      orderPlacedDateFrom: null,
      orderPlacedDateTo: null,
      abReceivedDateFrom: null,
      abReceivedDateTo: null,
      orderConfirmedDateFrom: null,
      orderConfirmedDateTo: null,
      fromDate: null,
      toDate: null,
    }));

    setFromDate(null);
    setToDate(null);
  };
  const handleFromDateChange = (date) => {
    const fromDate = date ? moment(date).format("YYYY-MM-DD") : null;
    setFromDate(fromDate);
  };

  // Handler function to update the "To Date" value
  const handleToDateChange = (date) => {
    const toDate = date ? moment(date).format("YYYY-MM-DD") : null;
    setToDate(toDate);
  };

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const calculateYearAndWeek = () => {
    let updatedFields = {};

    switch (dateType) {
      case "plannedLoadingDate":
        updatedFields = {
          plannedLoadingYear: year,
          plannedLoadingWeek: week,
          plannedLoadingDateFrom: null,
          plannedLoadingDateTo: null,
        };
        break;
      case "actualLoadingDate":
        updatedFields = {
          actualLoadingYear: year,
          actualLoadingWeek: week,
          actualLoadingDateFrom: null,
          actualLoadingDateTo: null,
        };
        break;
      case "orderConfirmedDate":
        updatedFields = {
          orderConfirmedYear: year,
          orderConfirmedWeek: week,
          orderConfirmedDateFrom: null,
          orderConfirmedDateTo: null,
        };
        break;
      case "abReceivedDate":
        updatedFields = {
          abReceivedYear: year,
          abReceivedWeek: week,
          abReceivedDateFrom: null,
          abReceivedDateTo: null,
        };
        break;
      default:
        return;
    }

    setFilter({
      ...filter,
      ...updatedFields,
    });
  };

  const calculateStartAndEndDate = () => {
    if (
      [
        "orderConfirmedDate",
        "plannedLoadingDate",
        "actualLoadingDate",
        "abReceivedDate",
      ].includes(dateType) &&
      year &&
      week
    ) {
      return;
    }
    let formattedStartDate = null;
    let formattedEndDate = null;
    if (year && !month && !week) {
      const startDate = new Date(year, 0, 1);
      const endDate = new Date(year, 11, 31);

      formattedStartDate = formatDate(startDate);
      formattedEndDate = formatDate(endDate);
    } else if (year && month) {
      const startDate = new Date(year, month - 1, 1);
      const endDate = new Date(year, month, 0);

      formattedStartDate = formatDate(startDate);
      formattedEndDate = formatDate(endDate);
    } else if (year && week) {
      const startDate = new Date(year, 0, 1);
      startDate.setDate(startDate.getDate() + (week - 1) * 7);

      const endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 6);

      formattedStartDate = formatDate(startDate);
      formattedEndDate = formatDate(endDate);
    } else if (fromDate && toDate) {
      formattedStartDate = fromDate;
      formattedEndDate = toDate;
    } else {
      formattedStartDate = null;
      formattedEndDate = null;
    }

    switch (dateType) {
      case "createdDt":
        setFilter({
          ...filter,
          createdDtFrom: formattedStartDate,
          createdDtTo: formattedEndDate,
        });
        break;
      case "plannedLoadingDate":
        setFilter({
          ...filter,
          plannedLoadingDateFrom: formattedStartDate,
          plannedLoadingDateTo: formattedEndDate,
        });
        break;
      case "actualLoadingDate":
        setFilter({
          ...filter,
          actualLoadingDateFrom: formattedStartDate,
          actualLoadingDateTo: formattedEndDate,
        });
        break;
      case "orderPlacedDate":
        setFilter({
          ...filter,
          orderPlacedDateFrom: formattedStartDate,
          orderPlacedDateTo: formattedEndDate,
        });
        break;
      case "abReceivedDate":
        setFilter({
          ...filter,
          abReceivedDateFrom: formattedStartDate,
          abReceivedDateTo: formattedEndDate,
        });
        break;
      case "orderConfirmedDate":
        setFilter({
          ...filter,
          orderConfirmedDateFrom: formattedStartDate,
          orderConfirmedDateTo: formattedEndDate,
        });
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      createdDtFrom: null,
      createdDtTo: null,
      plannedLoadingDateFrom: null,
      plannedLoadingDateTo: null,
      actualLoadingDateFrom: null,
      actualLoadingDateTo: null,
      orderPlacedDateFrom: null,
      orderPlacedDateTo: null,
      abReceivedDateFrom: null,
      abReceivedDateTo: null,
      orderConfirmedDateFrom: null,
      orderConfirmedDateTo: null,
    }));
  }, [dateType]);
  useEffect(() => {
    const isSpecialType = [
      "orderConfirmedDate",
      "plannedLoadingDate",
      "actualLoadingDate",
      "abReceivedDate",
    ].includes(dateType);
    const hasYearWeek = year && week;

    if (
      dateType &&
      ((year && !month && !week) ||
        (year && month) ||
        (year && week && !isSpecialType) ||
        (fromDate && toDate))
    ) {
      calculateStartAndEndDate();
    }
  }, [year, month, dateType, week, fromDate, toDate]);

  useEffect(() => {
    const isSpecialType = [
      "orderConfirmedDate",
      "plannedLoadingDate",
      "actualLoadingDate",
      "abReceivedDate",
    ].includes(dateType);
    if (isSpecialType && year && week) {
      calculateYearAndWeek();
    }
  }, [year, dateType, week]);

  const handleFilter = async () => {
    const updatedFilter = savedFilterData;
    gridRef.current.api.showLoadingOverlay();
    try {
      const res = await OAuthService.getPostList(searchUrl, updatedFilter);
      gridRef.current.api.hideOverlay();
      setRowData(res?.data?.content);
      dispatch(setSavedFilter(updatedFilter));
      dispatch(setHasFilter(true));
      getOrderTotalCalculation();
    } catch (error) {
      gridRef.current.api.hideOverlay();
      toast.error(error?.response?.data?.errorMessage || error.message);
      setRowData([]);
    }
  };
  const handleSearch = async () => {
    gridRef.current.api.showLoadingOverlay();

    try {
      const res = await OAuthService.addData(searchUrl, savedFilterData);
      gridRef.current.api.hideOverlay();
      setRowData(res?.data?.content);
      getOrderTotalCalculation();
      setSelectedRows([]);
      setHasSearch(false);
    } catch (error) {
      gridRef.current.api.hideOverlay();
      toast.error(error?.response?.data?.errorMessage || error.message);
      setRowData([]);
      setHasSearch(false);
    }
  };

  const handleEditRow = useCallback(() => {
    const selectedRows = gridRef.current.api.getSelectedRows();

    if (!selectedRows || selectedRows.length === 0) return;
    const initialInvalid = {};
    selectedRows.forEach((row) => {
      const hasIncomplete = [1, 2, 3].some((slot) => {
        const hasRange = !!row[`range${slot}Id`];
        return (
          hasRange &&
          (!row[`color${slot}Id`] ||
            !row[`carcass${slot}Id`] ||
            !row[`handle${slot}Id`])
        );
      });
      if (hasIncomplete) initialInvalid[row.id] = true;
    });
    setInvalidMaterialRows((prev) => ({ ...prev, ...initialInvalid }));

    originalEditDataRef.current = selectedRows.map((row) =>
      JSON.parse(JSON.stringify(row)),
    );

    selectedRows.forEach((row, idx) => {
      const rowIndex = rowData.findIndex((r) => r.id === row.id);

      if (rowIndex !== -1) {
        if (idx === 0) {
          gridRef.current.api.setFocusedCell(rowIndex, "abNumber");
        }

        gridRef.current.api.startEditingCell({
          rowIndex,
          colKey: "abNumber",
        });
      }
    });

    setIsEditing(true);
  }, [rowData]);
  const handleEditUniqueId = () => {
    if (!gridApi || !selectedRows?.length) return;
    setUniqueIdEdit(true);

    selectedRows.forEach((row) => {
      const rowNode = gridApi.getRowNode(row.id);

      if (rowNode) {
        gridApi.startEditingCell({
          rowIndex: rowNode.rowIndex,
          colKey: "uniqueId",
        });
      }
    });
  };
  const handleDownloadAb = async () => {
    const selectedRowDocumentNo = selectedRows.map((row) => row.documentNum);
    try {
      gridRef.current.api.showLoadingOverlay();
      const formData = new FormData();
      formData.append("documentNos", selectedRowDocumentNo);
      const file = await OAuthService.getPostPdf(
        downloadAbUrl,
        selectedRowDocumentNo,
      );

      const blob = new Blob([file?.data], { type: "application/zip" });
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "ABs.zip";
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      // setSelectedRows([]);
      gridRef.current.api.refreshCells();
      refreshCache();
    } catch (error) {
      toast.error("Error downloading AB's: " + error.message);
      // setSelectedRows([]);
      gridRef.current.api.refreshCells();
      refreshCache();
    } finally {
      gridRef.current.api.hideOverlay();
    }
  };

  const getContextMenuItems = useCallback(
    (event) => {
      const rowId = event?.node?.data?.id;
      const result = [
        {
          name: "Edit Order",
          icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
          disabled: hasOrderEditable,
          action: () => {
            handleEditRow();
          },
        },
        {
          name: "Open Order in New Tab",
          icon: '<span><i class="material-icons" style="font-size: 18px">open_in_new</i></span>',
          disabled: !rowId,
          action: () => {
            if (rowId) {
              const url = `/order/order-details/${rowId}`;
              window.open(url, "_blank");
            }
          },
        },
        "separator",
        "export",
        "chartRange",
      ];

      return result;
    },
    [rowData, hasOrderEditable],
  );
  const handleCellClick = (params) => {
    const { node, column, api } = params;
    if (column.colId === "srNo") return;

    if (!node.isSelected()) {
      node.setSelected(true);
      return;
    }

    const alreadyEditing = api
      .getEditingCells()
      .some(
        (c) =>
          c.rowIndex === node.rowIndex &&
          c.column.getColId() === column.getColId(),
      );
    if (alreadyEditing) return;

    if (params.colDef.editable) {
      api.startEditingCell({
        rowIndex: node.rowIndex,
        colKey: column.getColId(),
      });
    }
  };
  const onCellEditingStopped = (params) => {
    const data = params.data;

    const exists = updateRowDataRef.current.some((row) => row.id === data.id);

    if (!exists) {
      updateRowDataRef.current.push(data);
      setUpdateRowData([...updateRowDataRef.current]);
    }
  };
  const onCellEditingStarted = (params) => {
    setIsEditing(true);
    if (params.colDef.field !== "uniqueId") return;

    const editorInstances = params.api.getCellEditorInstances({
      columns: ["uniqueId"],
      rowNodes: [params.node],
    });

    const editorInstance = editorInstances[0];
    if (!editorInstance) return;

    const editorGui = editorInstance.getGui();
    const input =
      editorGui?.tagName === "INPUT"
        ? editorGui
        : editorGui?.querySelector("input");

    if (!input) return;

    // ---- EXISTING listener, unchanged ----
    const listener = (e) => {
      const value = e.target.value;
      const data = params.node.data;

      if (!data?.commissionName) return;

      const parts = data.commissionName.split("-");
      const isPRJ = ["PRJ", "CPRJ"].includes(data.orderCategory);

      const index = isPRJ ? parts.length - 1 : parts.length - 2;

      parts[index] = value;

      const updated = parts.join("-").toUpperCase();

      if (updated.length <= 35) {
        data.commissionName = updated;

        params.api.refreshCells({
          columns: ["commissionName"],
          rowNodes: [params.node],
        });
      }
    };

    input.addEventListener("input", listener);

    // ---- live blank-check listener ----
    const liveValidationListener = (e) => {
      const value = e.target.value.trim();
      const rowId = params.node.data.id;

      setInvalidUniqueIdRows((prev) => {
        const updated = { ...prev };
        if (value === "") {
          updated[rowId] = true;
        } else {
          delete updated[rowId];
        }
        return updated;
      });
    };

    input.addEventListener("input", liveValidationListener);

    params.api.addEventListener("cellEditingStopped", () => {
      input.removeEventListener("input", listener);
      input.removeEventListener("input", liveValidationListener);
    });
  };

  const onCellValueChanged = useCallback(async (props) => {
    const oldVal = props.oldValue || "";
    const newVal = props.newValue || "";

    if (String(oldVal).trim() === String(newVal).trim()) {
      return;
    }
    if (
      props.colDef.field === "revisedLpWg1" ||
      props.colDef.field === "revisedLpWg2"
    ) {
      const wg1 = Number(data.revisedLpWg1);
      const wg2 = Number(data.revisedLpWg2);
      data.totalRevisedLpWg1Wg2 =
        (isNaN(wg1) ? 0 : wg1) + (isNaN(wg2) ? 0 : wg2);
    }
    if (props.colDef.field === "uniqueId") {
      setInvalidUniqueIdRows((prev) => {
        const updated = { ...prev };
        if (String(newVal).trim() === "") {
          updated[props.data.id] = true;
        } else {
          delete updated[props.data.id];
        }
        return updated;
      });
    }
    if (props.colDef.field === "uniqueId") {
      const committedValue = String(newVal || "").trim();
      setInvalidUniqueIdRows((prev) => {
        const updated = { ...prev };
        if (committedValue === "") {
          updated[props.data.id] = true;
        } else {
          delete updated[props.data.id];
        }
        return updated;
      });
    }
    const data = props.data;

    const dateFields = [
      "orderPlacedDate",
      "abReceivedDate",
      "orderConfirmedDate",
      "plannedLoadingDate",
      "cutoffDate",
      "releaseDate",
      "actualLoadingDate",
    ];
    dateFields.forEach((field) => {
      if (data[field] === "Invalid date") {
        data[field] = "";
      }
    });

    if (
      props.colDef.field === "revisedLpWg1" ||
      props.colDef.field === "revisedLpWg2"
    ) {
      data.totalRevisedLpWg1Wg2 =
        Number(data.revisedLpWg1 || 0) + Number(data.revisedLpWg2 || 0);
    }
    const numericFields = [
      "revisedLpWg1",
      "revisedLpWg2",
      "volume",
      "weight",
      "splDiscWg1",
      "splDiscWg2",
      "splDiscWG1Payable",
      "splDiscWG2Payable",
    ];

    if (numericFields.includes(props.colDef.field)) {
      const raw = data[props.colDef.field];
      const isBad = raw !== "" && raw !== null && isNaN(Number(raw));
      setInvalidNumericRows((prev) => {
        const updated = { ...prev };
        const rowFields = { ...(updated[data.id] || {}) };
        if (isBad) rowFields[props.colDef.field] = true;
        else delete rowFields[props.colDef.field];
        if (Object.keys(rowFields).length) updated[data.id] = rowFields;
        else delete updated[data.id];
        return updated;
      });
    }
    if (props.colDef.field === "uniqueId" && data.commissionName) {
      const commissionName = String(data.commissionName || "");
      const oldUniqueId = String(props.oldValue || "").trim(); //
      const value = String(newVal || "").trim();

      const specialCharRegex = /^[a-zA-Z0-9()_\- ]*$/;
      if (!specialCharRegex.test(value)) {
        toast.warn("Special characters are not allowed!");
        props.node.setDataValue("uniqueId", oldUniqueId);
        return;
      }

      if (value.includes("/") || value.includes("\\")) {
        toast.warn("Unique ID must not contain '/' or '\\'.");
        props.node.setDataValue("uniqueId", oldUniqueId);
        return;
      }

      const isPRJ = ["PRJ", "CPRJ"].includes(data.orderCategory);

      const escapedOldId = oldUniqueId.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

      let regex = isPRJ
        ? new RegExp(`${escapedOldId}$`, "i")
        : new RegExp(`(^|-)${escapedOldId}(-|$)`, "i");

      let updatedCommissionName;

      if (regex.test(commissionName)) {
        updatedCommissionName = isPRJ
          ? commissionName.replace(regex, value)
          : commissionName.replace(regex, (m, p1, p2) => `${p1}${value}${p2}`);
      } else {
        console.warn("Regex failed — fallback replacing last segment");

        if (isPRJ) {
          updatedCommissionName =
            commissionName.substring(0, commissionName.lastIndexOf("-") + 1) +
            value;
        } else {
          const parts = commissionName.split("-");
          if (parts.length >= 3) {
            parts[1] = value; // UE1 position
            updatedCommissionName = parts.join("-");
          } else {
            updatedCommissionName = commissionName;
          }
        }
      }

      if (updatedCommissionName.length > 35) {
        toast.warn("Commission Name cannot exceed 35 characters!");
        props.node.setDataValue("uniqueId", oldUniqueId);
        return;
      }

      const updatedRow = {
        ...data,
        commissionName: updatedCommissionName.toUpperCase(),
        uniqueId: value,
      };

      props.api.applyTransaction({
        update: [updatedRow],
      });
    }

    const exists = updateRowDataRef.current.some(
      (rowValue) => rowValue.id === data.id,
    );

    const newArray = exists
      ? updateRowDataRef.current.map((rowValue) =>
          rowValue.id === data.id ? { ...rowValue, ...data } : rowValue,
        )
      : [...updateRowDataRef.current, data];

    updateRowDataRef.current = newArray;
    setUpdateRowData(newArray);

    if (
      props.colDef.field === "revisedLpWg1" ||
      props.colDef.field === "revisedLpWg2" ||
      props.colDef.field === "uniqueId"
    ) {
      props.api.refreshCells({ rowNodes: [props.node], force: true });
    }
    const hasIncompleteMaterial = [1, 2, 3].some((slot) => {
      const hasRange = !!data[`range${slot}Id`];
      return (
        hasRange &&
        (!data[`color${slot}Id`] ||
          !data[`carcass${slot}Id`] ||
          !data[`handle${slot}Id`])
      );
    });

    setInvalidMaterialRows((prev) => {
      const updated = { ...prev };
      if (hasIncompleteMaterial) {
        updated[data.id] = true;
      } else {
        delete updated[data.id];
      }
      return updated;
    });
  }, []);

  const cleanObject = (obj) => {
    const cleaned = {};

    for (const [key, value] of Object.entries(obj)) {
      if (["_links", "nolteProject", "abFiles"].includes(key)) {
        continue;
      }

      if (value === "") {
        cleaned[key] = null;
      } else if (value !== undefined) {
        cleaned[key] = value;
      }
    }

    return cleaned;
  };
  const safeNumber = (val) => {
    if (val === null || val === undefined || String(val).trim() === "")
      return 0;
    const n = Number(val);
    return isNaN(n) ? 0 : n;
  };
  const handleSubmit = async () => {
    try {
      // gridRef.current.api.stopEditing(true);
      gridRef.current.api.stopEditing();

      await new Promise((resolve) => setTimeout(resolve, 0));
      const rowsToUpdate = updateRowDataRef.current;

      if (rowsToUpdate.length > 0) {
        setIsSaving(true);

        await Promise.all(
          rowsToUpdate.map(async (freshData) => {
            const rowNode = gridRef.current.api.getRowNode(freshData.id);
            freshData = rowNode ? rowNode.data : freshData;
            // --- Existing calculation ---
            freshData.totalRevisedLpWg1Wg2 =
              Number(freshData.revisedLpWg1 || 0) +
              Number(freshData.revisedLpWg2 || 0);

            const safeFormatDate = (dateVal) => {
              if (
                !dateVal ||
                dateVal === "Invalid date" ||
                String(dateVal).trim() === ""
              ) {
                return null;
              }
              const m = moment(dateVal);
              return m.isValid() ? m.format("YYYY-MM-DDTHH:mm:ss.SSS") : null;
            };
            // --- Payload ---
            const payload = {
              ...freshData,
              freightId:
                freshData.updatedFreightId !== undefined
                  ? freshData.updatedFreightId
                  : freshData.freightId || null,
              revisedLpWg1: safeNumber(freshData.revisedLpWg1),
              revisedLpWg2: safeNumber(freshData.revisedLpWg2),
              splDiscWg1: safeNumber(freshData.splDiscWg1),
              splDiscWg2: safeNumber(freshData.splDiscWg2),
              splDiscWG1Payable: safeNumber(freshData.splDiscWG1Payable),
              splDiscWG2Payable: safeNumber(freshData.splDiscWG2Payable),
              volume: safeNumber(freshData.volume),
              weight: safeNumber(freshData.weight),
              range1Id: freshData.range1Id || "",
              color1Id: freshData.color1Id || "",
              carcass1Id: freshData.carcass1Id || "",
              handle1Id: freshData.handle1Id || "",

              range2Id: freshData.range2Id || "",
              color2Id: freshData.color2Id || "",
              carcass2Id: freshData.carcass2Id || "",
              handle2Id: freshData.handle2Id || "",

              range3Id: freshData.range3Id || "",
              color3Id: freshData.color3Id || "",
              carcass3Id: freshData.carcass3Id || "",
              handle3Id: freshData.handle3Id || "",

              orderPlacedDate: safeFormatDate(freshData.orderPlacedDate),
              abReceivedDate: safeFormatDate(freshData.abReceivedDate),
              orderConfirmedDate: safeFormatDate(freshData.orderConfirmedDate),
              plannedLoadingDate: safeFormatDate(freshData.plannedLoadingDate),
              cutoffDate: safeFormatDate(freshData.cutoffDate),
              actualLoadingDate: safeFormatDate(freshData.actualLoadingDate),
            };
            const cleanedOrder = cleanObject(payload);

            const response = await OAuthService.updateData(
              url,
              payload.id,
              cleanedOrder,
            );

            if (response.status === 200) {
              // (optional) avoid multiple toasts if many rows
              toast.success("All selected rows updated successfully");
              // toast.success("Data Updated Successfully");
            }
          }),
        );

        // --- Reset ---
        setUpdateRowData([]);
        updateRowDataRef.current = [];
        setIsEditing(false);
        originalEditDataRef.current = {};
        setInvalidUniqueIdRows({});
        setInvalidColorRows({});
        setInvalidMaterialRows({});
        gridRef.current.api.refreshCells();
        setIsSaving(false);
      }
    } catch (error) {
      const backendError =
        error?.response?.data?.message ||
        error?.response?.data?.errorMessage ||
        error.message;

      toast.error("Failed: " + backendError);

      setUpdateRowData([]);
      updateRowDataRef.current = [];
      setIsEditing(false);
      originalEditDataRef.current = {};
      setInvalidUniqueIdRows({});
      setInvalidColorRows({});
      setInvalidMaterialRows({});
      setIsSaving(false);
    }
  };

  const handleCancelOrder = async () => {
    const updatedRowData = [...rowData];

    await Promise.all(
      selectedRows.map(async (row) => {
        try {
          const { data } = await OAuthService.getPostList(
            `${changeOrderStatus}?orderId=${row.id}&status=CANCELLED`,
            {},
          );
          if (data && data?.id) {
            const rowIndex = updatedRowData.findIndex((r) => r.id === data.id);
            if (rowIndex !== -1) {
              updatedRowData[rowIndex] = {
                ...updatedRowData[rowIndex],
                orderStatus: data.orderStatus,
              };
            }
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.errorMessage ||
              error.message ||
              "Order is not Cancelled",
          );
          console.error(error);
        }
      }),
    ).finally(() => {
      setRowData(updatedRowData);
      gridRef.current.api.refreshCells();
      refreshCache();
      handleCloseCancelOrder();
    });
  };

  const handleRestoreOrders = async () => {
    const orderIds = selectedRows.map((row) => row.id);
    try {
      gridRef.current.api.showLoadingOverlay();
      await OAuthService.addData(restoreOrdersUrl, orderIds);
      toast.success("Orders restored successfully");
      // setSelectedRows([]);
      loadData();
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error.message ||
          "Failed to restore orders",
      );
    } finally {
      gridRef.current.api.hideOverlay();
    }
  };

  const baseStyles = customStyles("", "", "", "", "", "controlHeight");
  const showroomFilterOptions = hasShwrmMngrRole
    ? Array.isArray(companyShowroom)
      ? companyShowroom
      : []
    : showroomOptions;
  const selectStyleConfig = {
    ...baseStyles,
    control: (provided, state) => ({
      ...provided,
      minHeight: "30px",
      height: "30px",
      boxShadow: "none",
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      cursor: "pointer",
      padding: "0",
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: "28px",
      maxHeight: "28px",
      padding: "0 4px",
      display: "flex",
      flexWrap: "wrap",
      overflowY: "auto",
      overflowX: "hidden",
      alignItems: "center",
      alignContent: "flex-start",
      position: "relative",
      "&::-webkit-scrollbar": {
        width: "4px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.divider,
        borderRadius: "4px",
      },
    }),
    input: (provided, state) => ({
      ...provided,
      margin: "0",
      padding: "0",
      color: theme.palette.text.primary,
      fontSize: "10px",
      lineHeight: "28px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "28px",
      padding: "0",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "2px 4px",
      color: theme.palette.text.secondary,
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: "2px 4px",
      color: theme.palette.text.secondary,
    }),
    placeholder: (provided, state) => ({
      ...provided,
      fontSize: "10px",
      color: theme.palette.text.secondary,
      margin: "0",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      fontSize: "10px",
      color: theme.palette.text.primary,
      margin: "0",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.15)"
          : "rgba(0, 0, 0, 0.08)", // DYNAMIC CHIP BG
      margin: "2px 2px 2px 0",
      alignItems: "center",
      borderRadius: "3px",
      flexShrink: 0,
      width: "calc(100% - 2px)",
      justifyContent: "space-between",
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      fontSize: "9px",
      color: theme.palette.text.primary,
      padding: "2px 4px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      padding: "2px",
      color: theme.palette.text.secondary,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
        color: "#fff",
      },
    }),
    menuPortal: (provided, state) => ({
      ...provided,
      zIndex: 9999,
    }),
    noOptionsMessage: (provided, state) => ({
      ...provided,
      fontSize: "10px",
      color: theme.palette.text.secondary,
      padding: "4px 8px",
    }),
  };

  const textFieldStyleConfig = {
    "& .MuiInputBase-root": {
      height: "30px",
      minHeight: "30px",
      fontSize: "10px",
      color: theme.palette.text.primary,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.divider,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.text.secondary,
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "0 8px",
      height: "30px",
      lineHeight: "30px",
      boxSizing: "border-box",
    },
    "& .MuiInputBase-input::placeholder": {
      fontSize: "10px",
      color: theme.palette.text.secondary,
      opacity: 1,
      lineHeight: "30px",
    },
    width: "100%",
  };

  return (
    <>
      <SelectedStatus.Provider value={[selectedStatus, setSelectedStatus]}>
        <FormPageHeader
          componentName="Order Management System"
          pageName="Order Management System"
          currentPage="Order Management System"
          orderHeaderAction={orderHeaderAction()}
        >
          <div className="flex flex-col my-8 px-4 sm:flex sm:flex-row">
            <Cards
              hasPartnerRole={hasPartnerRole}
              hasPartnerAdminRole={hasPartnerAdminRole}
              hasShwrmMngrRole={hasShwrmMngrRole}
              hasCustomerRole={hasCustomerRole}
            />
          </div>

          <Box className="flex flex-col w-full px-4" sx={{ pb: 1, pt: 1 }}>
            <div className="flex flex-col w-full">
              <div className="relative w-full">
                <div
                  className="flex flex-row items-center gap-4 w-full overflow-x-auto pb-8 custom-horizontal-scrollbar"
                  style={{ WebkitOverflowScrolling: "touch" }}
                >
                  <Box className="flex-shrink-0 w-[150px]">
                    <TextField
                      type="text"
                      placeholder={"Quick Filter"}
                      id="filter-text-box"
                      onInput={onFilterTextBoxChanged}
                      sx={textFieldStyleConfig}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton edge="end" sx={{ p: 0 }}>
                              <FuseSvgIcon size={14}>
                                heroicons-outline:search
                              </FuseSvgIcon>
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                  </Box>

                  <Box className="flex-shrink-0 w-[160px]">
                    <Select
                      placeholder="Customer"
                      name="custNum"
                      value={
                        hasCustomerRole
                          ? customerName
                          : filter.custNum &&
                            customerOptions &&
                            customerOptions.filter(
                              (obj) => filter.custNum === obj.value,
                            )
                      }
                      onChange={(e, action) =>
                        handleSelectChange(e, action, "custNum")
                      }
                      options={customerOptions}
                      isDisabled={hasCustomerRole}
                      styles={selectStyleConfig}
                      menuPortalTarget={document.body}
                      isClearable
                    />
                  </Box>

                  <Box className="flex-shrink-0 w-[180px]">
                    <Select
                      placeholder={
                        hasShwrmMngrRole ? "All my showrooms" : "Showroom"
                      }
                      name="showroomNum"
                      isMulti
                      options={showroomFilterOptions}
                      styles={selectStyleConfig}
                      menuPortalTarget={document.body}
                      value={showroomFilterOptions.filter((opt) =>
                        filter.showroomNum
                          ?.map(String)
                          .includes(String(opt.value)),
                      )}
                      onChange={(e) => handleMultiChange(e, "showroomNum")}
                    />
                  </Box>

                  <Box className="flex-shrink-0 w-[140px]">
                    <Select
                      placeholder="Vendor"
                      name="vendorShortKey"
                      value={
                        factoryVendors.find(
                          (opt) => opt.value === filter.vendorShortKey?.[0],
                        ) || null
                      }
                      onChange={(e, action) =>
                        handleSelectChange(e, action, "vendorShortKey")
                      }
                      options={factoryVendors}
                      styles={selectStyleConfig}
                      menuPortalTarget={document.body}
                      isClearable
                    />
                  </Box>

                  <Box className="flex-shrink-0 w-[180px]">
                    <TextField
                      sx={textFieldStyleConfig}
                      placeholder="Commission Name"
                      type="text"
                      name="commissionName"
                      value={filter.commissionName}
                      onChange={(e) => handleTextChange(e)}
                      variant="outlined"
                    />
                  </Box>

                  <Box className="flex-shrink-0 w-[130px]">
                    <TextField
                      sx={textFieldStyleConfig}
                      placeholder="AB Number"
                      type="text"
                      name="abNumber"
                      value={filter.abNumber}
                      onChange={(e) => handleTextChange(e)}
                      variant="outlined"
                    />
                  </Box>

                  <Box className="flex-shrink-0 w-[140px]">
                    <Select
                      required
                      placeholder={"History"}
                      name="history"
                      value={
                        dateType &&
                        historyOptionOther &&
                        historyOptionOther.filter(
                          (obj) => dateType === obj.value,
                        )
                      }
                      onChange={(e, action) => handleDateTypeChange(e, action)}
                      options={
                        hasCustomerRole
                          ? historyOptionCustomer
                          : historyOptionOther
                      }
                      styles={selectStyleConfig}
                      menuPortalTarget={document.body}
                      isClearable
                    />
                  </Box>

                  <Box className="flex-shrink-0 w-[150px]">
                    <CustomDatePicker
                      placeholder="From Date"
                      className="h-[30px] w-full"
                      sx={textFieldStyleConfig}
                      format={"dd-MM-yyyy"}
                      name={"fromDate"}
                      value={fromDate}
                      maxDate={
                        dateType === "plannedLoadingDate"
                          ? moment().add(6, "months").toDate()
                          : new Date()
                      }
                      handleChange={handleFromDateChange}
                      componentsProps={{
                        actionBar: { actions: ["clear"] },
                      }}
                      disabled={month || week || year ? true : false}
                    />
                  </Box>

                  <Box className="flex-shrink-0 w-[150px]">
                    <CustomDatePicker
                      placeholder="To Date"
                      className="h-[30px] w-full"
                      sx={textFieldStyleConfig}
                      format={"dd-MM-yyyy"}
                      name={"toDate"}
                      value={toDate}
                      minDate={new Date(fromDate)}
                      maxDate={
                        dateType === "plannedLoadingDate"
                          ? moment().add(6, "months").toDate()
                          : new Date()
                      }
                      handleChange={handleToDateChange}
                      componentsProps={{
                        actionBar: { actions: ["clear"] },
                      }}
                      disabled={month || week || year ? true : false}
                    />
                  </Box>

                  <Box className="flex-shrink-0 w-[120px]">
                    <Select
                      required
                      placeholder={"Year"}
                      name="year"
                      value={
                        year &&
                        yearOptions &&
                        yearOptions.filter((obj) => year === obj.value)
                      }
                      onChange={(e, action) =>
                        handleSelectChange(e, action, "year")
                      }
                      options={yearOptions}
                      styles={selectStyleConfig}
                      menuPortalTarget={document.body}
                      isDisabled={!!fromDate || !!toDate}
                      isClearable
                    />
                  </Box>

                  <Box className="flex-shrink-0 w-[120px]">
                    <Select
                      required
                      placeholder={"Month"}
                      name="month"
                      value={
                        month &&
                        monthOption &&
                        monthOption.filter((obj) => month === obj.value)
                      }
                      onChange={(e, action) =>
                        handleSelectChange(e, action, "month")
                      }
                      options={monthOption}
                      styles={selectStyleConfig}
                      menuPortalTarget={document.body}
                      isDisabled={
                        !!fromDate || !!toDate || (year && week) || week
                      }
                      isClearable
                    />
                  </Box>

                  <Box className="flex-shrink-0 w-[120px]">
                    <Select
                      required
                      placeholder={"Week"}
                      name="week"
                      value={
                        week &&
                        weekOption &&
                        weekOption.filter((obj) => week === obj.value)
                      }
                      onChange={(e, action) =>
                        handleSelectChange(e, action, "week")
                      }
                      options={weekOption}
                      styles={selectStyleConfig}
                      menuPortalTarget={document.body}
                      isDisabled={
                        !!fromDate || !!toDate || (year && month) || month
                      }
                      isClearable
                    />
                  </Box>

                  <Box className="flex-shrink-0 w-[40px] sticky right-0 bg-dark-paper pl-2 z-10">
                    <Tooltip title={"Advanced Search"}>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        sx={{
                          minWidth: "auto",
                          height: "30px",
                          width: "100%",
                          px: 0,
                        }}
                        onClick={handleAdvanceSearch}
                      >
                        <FuseSvgIcon size={16}>material-solid:tune</FuseSvgIcon>
                      </Button>
                    </Tooltip>
                  </Box>
                </div>
                <div className="absolute top-0 right-40 bottom-8 w-40 pointer-events-none bg-gradient-to-r from-transparent to-dark-paper hidden sm:block z-10" />
              </div>

              {showSearch && (
                <AdvancedSearch
                  filter={filter}
                  setFilter={setFilter}
                  vendorId={vendorId}
                  setVendorId={setVendorId}
                  rangeId={rangeId}
                  setRangeId={setRangeId}
                  custCountry={custCountry}
                  hasCustomerRole={hasCustomerRole}
                  hasSopAdminRole={hasSopAdminRole}
                />
              )}
            </div>
          </Box>
        </FormPageHeader>

        <div
          className={clsx(
            classes.root,
            "w-full min-h-[500px] sm:h-[75vh] mt-2",
            theme.palette.mode === "dark"
              ? "ag-theme-alpine-dark"
              : "ag-theme-alpine",
          )}
        >
          {listView && (
            <>
              <div
                style={{
                  flex: "1 1 auto",
                  width: "100%",
                  height: "100%",
                  minWidth: 0,
                }}
              >
                <AgGridTable
                  rowData={rowData}
                  columnDefs={selectColumns}
                  defaultColDef={defaultColDef}
                  onGridReady={onGridReady}
                  gridRef={gridRef}
                  onCellEditingStarted={onCellEditingStarted}
                  onCellEditingStopped={onCellEditingStopped}
                  getContextMenuItems={getContextMenuItems}
                  onRowDoubleClicked={onRowDoubleClicked}
                  onRowClicked={onRowClicked}
                  onSelectionChanged={onSelectionChanged}
                  pagination={false}
                  rowHeight={22}
                  headerHeight={28}
                  editable={hasAdminRole ? true : false}
                  editType={"fullRow"}
                  wrapHeaderText={true}
                  autoHeaderHeight={true}
                  onFirstDataRendered={onFirstDataRendered}
                  enableRowGroup={true}
                  groupRowMinWidth={150}
                  saveGridStateName={"orderList"}
                  rowSelection={"multiple"}
                  suppressRowClickSelection={hasCustomerRole ? false : true}
                  stopEditingWhenCellsLoseFocus={true}
                  onCellValueChanged={onCellValueChanged}
                  getRowId={(params) => params.data.id}
                  getRowStyle={getRowStyle}
                  singleClickEdit={false}
                  onCellClicked={handleCellClick}
                />
              </div>

              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChangePanel("panel1")}
              >
                <AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                  className="h-24 min-h-24"
                >
                  <Typography>Total</Typography>
                </AccordionSummary>
                <AccordionDetails className="!p-4 overflow-hidden">
                  <Box
                    sx={{ background: theme.palette.background.paper, p: 2 }}
                  >
                    {hasCustomerRole ? (
                      <ul className="total-list grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 items-center">
                        <li className="flex flex-row items-center gap-3">
                          <label className="mr-6">Quantity</label>
                          <Box
                            sx={{
                              background: theme.palette.grey[900],
                              px: 1,
                              py: 0.5,
                              borderRadius: 8,
                              color: `${theme.palette.common.white} !important`,
                            }}
                          >
                            {totalValueFormatted(
                              orderCalculation.totalQty
                                ? orderCalculation.totalQty
                                : 0,
                              "",
                            )}
                          </Box>
                        </li>
                        <li className="flex flex-row items-center gap-3">
                          <label className="mr-6">List Price</label>
                          <Box
                            sx={{
                              background: theme.palette.grey[900],
                              px: 1,
                              py: 0.5,
                              borderRadius: 8,
                              color: `${theme.palette.common.white} !important`,
                            }}
                          >
                            {totalValueFormatted(
                              orderCalculation.totalListPrice
                                ? orderCalculation.totalListPrice
                                : 0,
                              "",
                            )}
                          </Box>
                        </li>
                        <li className="flex flex-row items-center gap-3">
                          <label className="mr-6">Packs</label>
                          <Box
                            sx={{
                              background: theme.palette.grey[900],
                              px: 1,
                              py: 0.5,
                              borderRadius: 8,
                              color: `${theme.palette.common.white} !important`,
                            }}
                          >
                            {totalValueFormatted(
                              orderCalculation.totalPacks
                                ? orderCalculation.totalPacks
                                : 0,
                              "",
                            )}
                          </Box>
                        </li>
                        <li className="flex flex-row items-center gap-3">
                          <label className="mr-6">Volume</label>
                          <Box
                            sx={{
                              background: theme.palette.grey[900],
                              px: 1,
                              py: 0.5,
                              borderRadius: 8,
                              color: `${theme.palette.common.white} !important`,
                            }}
                          >
                            {totalValueFormatted(
                              orderCalculation.totalVolume
                                ? orderCalculation.totalVolume
                                : 0,
                              "volume",
                            )}
                          </Box>
                        </li>
                        <li className="flex flex-row items-center gap-3">
                          <label className="mr-6">Weight</label>
                          <Box
                            sx={{
                              background: theme.palette.grey[900],
                              px: 1,
                              py: 0.5,
                              borderRadius: 8,
                              color: `${theme.palette.common.white} !important`,
                            }}
                          >
                            {totalValueFormatted(
                              orderCalculation.totalWeight
                                ? orderCalculation.totalWeight
                                : 0,
                              "weight",
                            )}
                          </Box>
                        </li>
                      </ul>
                    ) : (
                      <>
                        <ul className="total-list grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-9 gap-3 items-center">
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">Quantity</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.totalQty
                                  ? orderCalculation.totalQty
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">List Price</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.totalListPrice
                                  ? orderCalculation.totalListPrice
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">RCBL</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.totalReceivables
                                  ? orderCalculation.totalReceivables
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">PBL</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.totalPayables
                                  ? orderCalculation.totalPayables
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">PBL AFTR VAT</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.payableAfterGermanVat
                                  ? orderCalculation.payableAfterGermanVat
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">PBL AFTR TRN DISC</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.payableAfterTransferDisc
                                  ? orderCalculation.payableAfterTransferDisc
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">Volume</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.totalVolume
                                  ? orderCalculation.totalVolume
                                  : 0,
                                "volume",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">Weight</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.totalWeight
                                  ? orderCalculation.totalWeight
                                  : 0,
                                "weight",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">Packs</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.totalPacks
                                  ? orderCalculation.totalPacks
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                        </ul>

                        <Divider
                          sx={{ my: 2, borderColor: theme.palette.divider }}
                        />

                        <ul className="total-list grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-9 gap-3">
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">Kitchen</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.totalKitchen
                                  ? orderCalculation.totalKitchen
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">Wardrobes</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.totalWardrobes
                                  ? orderCalculation.totalWardrobes
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">Bed Sets</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.totalBedSets
                                  ? orderCalculation.totalBedSets
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">Chest</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.totalChest
                                  ? orderCalculation.totalChest
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">TV/Living Room</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.totalTVLivingRooms
                                  ? orderCalculation.totalTVLivingRooms
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">Gest to Cust</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.guestOfCustomer
                                  ? orderCalculation.guestOfCustomer
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">%Gest to Cust.</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.percentGuestToCustomer
                                  ? orderCalculation.percentGuestToCustomer
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">Fact. Gesture</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.factGesture,
                              )}
                            </Box>
                          </li>
                          <li className="flex flex-row items-center gap-3">
                            <label className="mr-6">% Fact. Gest</label>
                            <Box
                              sx={{
                                background: theme.palette.grey[900],
                                px: 1,
                                py: 0.5,
                                borderRadius: 8,
                                color: `${theme.palette.common.white} !important`,
                              }}
                            >
                              {totalValueFormatted(
                                orderCalculation.percentFactGesture
                                  ? orderCalculation.percentFactGesture
                                  : 0,
                                "",
                              )}
                            </Box>
                          </li>
                        </ul>
                      </>
                    )}
                  </Box>
                </AccordionDetails>
              </Accordion>
            </>
          )}
        </div>
      </SelectedStatus.Provider>

      <Dialog
        open={openCancel}
        onClose={handleCloseCancelOrder}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to cancel the order?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelOrder}>Yes</Button>
          <Button onClick={handleCloseCancelOrder} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <DialogBox
        open={pramotionDia}
        handleClose={handlePramotionDiaClose}
        handleSumbit={changeActiveStatus}
        customeTitel={
          promotionalStatus
            ? "Do you really want to activate skip promotion?"
            : "Do you really want to deactivate skip promotion?"
        }
      />

      <Dialog open={openType} fullWidth maxWidth="xs" onClose={handleCloseType}>
        <DialogActions>
          <Button onClick={handleCloseType} autoFocus>
            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
          </Button>
        </DialogActions>

        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <DialogContentText id="alert-dialog-description" align="center">
              <Typography component={"p"} style={{ marginBottom: "16px" }}>
                What type of order would you like to create?
              </Typography>

              <Button
                color="secondary"
                variant="contained"
                onClick={handleNewOrderType}
                sx={{ mx: 1 }}
              >
                New Order
              </Button>
              <Button
                color="secondary"
                variant="contained"
                onClick={handlePartOrder}
                sx={{ mx: 1 }}
              >
                Part Order
              </Button>
            </DialogContentText>
          </Box>
        </DialogContent>
      </Dialog>
      <Backdrop
        open={isExportingAo}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default memo(OrderList);
